import { Component, Renderer2, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { AlertController, ModalController, NavParams } from 'ionic-angular';
import { MenuService } from '../../providers/menu-service';
import { CertificadoService } from '../../providers/certificado-service';
import { GestaoPcaService } from '../../providers/gestao-pca-service';
import { UsuarioService } from '../../providers/usuario-service';
import { AlertService } from '../../providers/alert-service';

import { ModalAutuacaoPage } from '../modais/modal-autuacao/modal-autuacao';

// import 'highcharts/adapters/standalone-framework.src';

const Highcharts = require('highcharts');
declare var jsPDF: any;
declare var require: any;
import html2canvas from 'html2canvas';
import saveAs from 'file-saver';

import * as $ from "jquery";
import { FileService } from '../../providers/file-service';
import { ArquivosService } from '../../providers/arquivos-service';

declare function unescape(s: string): string;

declare global {
    interface Window { html2canvas: any; saveAs: any; }
}

@Component({
    selector: 'page-certificado',
    templateUrl: 'certificado.html',
    providers: [
        CertificadoService
    ]
})
export class CertificadoPage {
    @ViewChildren('chart') public charts: QueryList<ElementRef>;
    // Lista Construtora da Página
    PCAAtiva: any;
    loading: boolean = true;
    limiteDiferencaLimiteLegal: any = 25.00;

    dataGeracao: any;

    private chartEl: ElementRef;
    private _chart: any;
    listaDadosRegra2: any = [];
    listaDadosRegra2Aux: any = [];

    listaAlienacoes: any = [];
    listaDoacoes: any = [];

    idModuloPca: any;

    options: any = {
        placeholder: '',
        spellcheck: true,
        tabsize: 2,
        height: 500,
        toolbar: [
            ['misc', ['codeview', 'undo', 'redo']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['font', ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript', 'clear']],
            ['fontsize', ['fontname', 'fontsize', 'color']],
            ['para', ['style0', 'ul', 'ol', 'paragraph', 'height']],
            ['insert', ['table', 'picture', 'link', 'video', 'hr']],
            ['misc', ['print']],
        ],
        fontNames: ['Helvetica', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Roboto', 'Times'],
        lang: 'pt-BR'
    };

    certificado: any;
    preCertificado: any;
    // ${this.certificado}
    certificadoContent: string;

    monitoramentoBaixa: any = [];
    monitoramentoReincidencia: any = [];
    monitoramentoOutros: any = [];

    numeracao: any = {
        nmProcesso: "",
        nmCertificado: "",
        nmRelator: ""
    }

    //Construtor da Página
    constructor(public alertCtrl: AlertController,
        private certificadoService: CertificadoService,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        private gestaoPcaService: GestaoPcaService,
        private usuarioService: UsuarioService,
        private fileService: FileService,
        private arquivoService: ArquivosService,
        private alertService: AlertService,
        public menuService: MenuService,
        public renderer: Renderer2) {

        this.dataGeracao = new Date();

        // this.carregaPreCertificado();
    }

//     formatarProcesso(nrProcesso) {
//         return nrProcesso.substring(4, 9) + '/' + nrProcesso.substring(0, 4) + '-' + nrProcesso.substring(9, 10);
//     }

//     gerarNumeracao() {
//         this.loading = true;

//         this.certificadoService.buscarProcesso().subscribe(next => {
//             this.numeracao.nmProcesso = this.formatarProcesso(next.numeroProcesso);
//             this.numeracao.nmCertificado = next.numeroCertificado;
//             this.numeracao.nmRelator = next.nmRelator;

//             this.certificadoContent = this.certificadoContent.replace("nProcesso", "" + this.numeracao.nmProcesso);
//             this.certificadoContent = this.certificadoContent.replace("nCertificado", "" + this.numeracao.nmCertificado);
//             this.certificadoContent = this.certificadoContent.replace("nmRelator", "" + this.numeracao.nmRelator);

//             this.loading = false;
//         }, error => {
//             this.alertService.mostraAlerta("", "Ocorreu um erro ao gerar a numeração do certificado: " + error.mensagem);
//             this.loading = false;
//         });
//     }

//     carregaDadosGerais() {
//         this.PCAAtiva = this.gestaoPcaService.getPCA();

//         this.certificadoService.obterCertificado().subscribe(data => {
//             this.certificado = data;

//             if (data != null &&
//                 data.gestaoMateriaisCertificado.analiseAlienacoesDoacoes &&
//                 data.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.analises.length > 0) {
//                 this.listaAlienacoes = this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.analises.filter(item1 => item1.decreto == "");
//                 this.listaDoacoes = this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.analises.filter(item2 => item2.valorAlienacao == 0);
//             }

//             if (data != null &&
//                 data.analiseLicitacaoRegra2 != null &&
//                 data.analiseLicitacaoRegra2.modalidades != null &&
//                 data.analiseLicitacaoRegra2.modalidades.length > 0) {

//                 this.listaDadosRegra2Aux = data.analiseLicitacaoRegra2.modalidades.map((elem) => ([elem.descricao, elem.valorTotal]));

//                 for (let i = 0; i < this.listaDadosRegra2Aux.length; i++) {
//                     this.listaDadosRegra2.push({
//                         name: this.listaDadosRegra2Aux[i][0],
//                         y: this.listaDadosRegra2Aux[i][1]
//                     });
//                 }
//             }

//             if (this.certificado != undefined && this.certificado.lstMonitoramentoCertificado != undefined && this.certificado.lstMonitoramentoCertificado.length > 0) {
//                 this.monitoramentoBaixa = this.certificado.lstMonitoramentoCertificado.filter((determinacao) => determinacao.flBaixa == true);
//                 this.monitoramentoReincidencia = this.certificado.lstMonitoramentoCertificado.filter((determinacao) => determinacao.flReincidencia == true);
//                 this.monitoramentoOutros = this.certificado.lstMonitoramentoCertificado.filter((determinacao) => determinacao.flReincidencia == false && determinacao.flBaixa == false);

//             }

//             this.certificadoContent = `
//             <table class="MsoNormalTable" align="center" style="border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 5.4pt 0cm 5.4pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr style="height:18.25pt">
//                         <td style="width:125.1pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt; height:18.25pt"
//                             width="147">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">PROCESSO Nº:</span></b></p>
//                         </td>
//                         <td style="width:148.55pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt; height:18.25pt"
//                             width="208">
//                             <p contenteditable="false" readonly="readonly" class="MsoBodyText" style="text-align:left;layout-grid-mode:char" align="left"><b style="mso-bidi-font-weight:normal"><span
//                                         style="mso-bidi-font-size:11.0pt; line-height:150%">nProcesso</span></b></p>
//                         </td>
//                         <td style="width:128.6pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt; height:18.25pt"
//                             width="175">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">CERTIFICADO Nº:</span></b></p>
//                         </td>
//                         <td style="width:86.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:18.25pt"
//                             width="115">
//                             <p contenteditable="false" readonly="readonly" class="MsoBodyText" style="text-align:right;layout-grid-mode: char" align="right"><b style="mso-bidi-font-weight:normal"><span
//                                         style="mso-bidi-font-size: 11.0pt;line-height:150%">nCertificado</span></b></p>
//                         </td>
//                     </tr>
//                     <tr style="height:18.3pt">
//                         <td style="width:125.1pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-top-alt:solid black .5pt; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 5.4pt 0cm 5.4pt; height:18.3pt"
//                             width="147">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">ENTIDADE:</span></b></p>
//                         </td>
//                         <td colspan="3" style="width:373.15pt;border:solid black 1.0pt; border-top:none;mso-border-top-alt:solid black .5pt;mso-border-alt:solid black .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:18.3pt"
//                             width="498">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">${this.certificado.dadosGerais.nmOrgao}</span></b></p>
//                         </td>
//                     </tr>
//                     <tr style="height:18.25pt">
//                         <td style="width:125.1pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-top-alt:solid black .5pt; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt; height:18.25pt"
//                             width="147">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">NATUREZA:</span></b></p>
//                         </td>
//                         <td colspan="3" style="width:373.15pt;border:solid black 1.0pt; border-top:none;mso-border-top-alt:solid black .5pt;mso-border-alt:solid black .5pt; background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:18.25pt"
//                             width="498">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">PRESTAÇÃO DE CONTAS ANUAL - EXERCÍCIO DE
//                                         ${this.PCAAtiva.dsAnoexercicio}</span></b></p>
//                         </td>
//                     </tr>
//                     <tr style="height:18.3pt">
//                         <td style="width:125.1pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-top-alt:solid black .5pt; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 5.4pt 0cm 5.4pt; height:18.3pt"
//                             width="147">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">RELATOR:</span></b></p>
//                         </td>
//                         <td colspan="3" style="width:373.15pt;border:solid black 1.0pt; border-top:none;mso-border-top-alt:solid black .5pt;mso-border-alt:solid black .5pt; padding:0cm 5.4pt 0cm 5.4pt;height:18.3pt"
//                             width="498">
//                             <p contenteditable="false" readonly="readonly" class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">nmRelator</span></b></p>
//                         </td>
//                     </tr>
//                     <tr style="mso-yfti-lastrow:yes;height:18.3pt">
//                         <td style="width:125.1pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-top-alt:solid black .5pt; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt; height:18.3pt"
//                             width="147">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">TIPO DE ANÁLISE:</span></b></p>
//                         </td>
//                         <td colspan="3" style="width:373.15pt;border:solid black 1.0pt; border-top:none;mso-border-top-alt:solid black .5pt;mso-border-alt:solid black .5pt; background:#D9D9D9;padding:0cm 5.4pt 0cm 5.4pt;height:18.3pt"
//                             width="498">
//                             <p class="MsoBodyText" style="layout-grid-mode:char"><b style="mso-bidi-font-weight: normal"><span
//                                         style="mso-bidi-font-size:11.0pt;line-height:150%">EXAME INICIAL NÃO PRESENCIAL</span></b></p>
//                         </td>
//                     </tr>
//                 </tbody>
//             </table>
//             <br />
//             <br />
//             <p class="MsoBodyTextIndent" style="text-align:justify;margin-left:204.1pt;text-indent:0cm; mso-line-height-alt:10.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-weight:normal">ASSUNTO:
//                     Análise inicial da Prestação de Contas Anual da ${this.certificado.dadosGerais.nmOrgao}, relativa ao exercício
//                     financeiro de ${this.PCAAtiva.dsAnoexercicio}. Órgão Julgador: CÂMARA.</span></p>
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">1. CONSIDERAÇÕES PRELIMINARES</span></b></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.9pt;line-height: 150%"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">Versam
//                     os presentes autos acerca das Contas Anuais do <b>${this.certificado.dadosGerais.nmOrgao}</b>, relativas ao <b>exercício
//                         financeiro de ${this.PCAAtiva.dsAnoexercicio},</b> constantes do Plano de Auditoria
//                     elaborado pela Secretaria de Controle Externo -
//                     SECEX, aprovado pela Presidência deste Tribunal, para serem instruídas de forma não presencial,<b> </b>mediante
//                     o exame da documentação entregue pelo jurisdicionado e/ou a compilação de dados extraídos dos sistemas
//                     corporativos do Estado e de apoio à gestão.</span></p>
//             <p class="MsoNormal" style="margin-top:5.65pt;text-align:justify;text-indent: 70.85pt;line-height:150%"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%; font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;color:black; background:white">${this.certificado.dadosGerais.dsGeral}</span></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.85pt;line-height: 150%;text-autospace:ideograph-numeric"><span
//                     style="font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial; color:black;background:white">O
//                     referido órgão tem por competência: </span></p>
//             <p class="MsoNormal" style="margin-left:36.0pt;text-align:justify;text-indent: -18.0pt;line-height:150%;mso-list:l2 level1 lfo3;tab-stops:list 36.0pt"><span
//                     style="font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:Arial"><span
//                         style="mso-list:Ignore">${this.certificado.dadosGerais.dsCompetencias}<span style="font-family:&quot;Arial&quot;,sans-serif;font:7.0pt &quot;Times New Roman&quot;">
//                         </span></span></span></p>
            
//             <p class="MsoNormal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-family:&quot;Arial&quot;,sans-serif; color:black;background:yellow"></span></p>
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">2. PEÇAS PROCESSUAIS</span></b></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:72.0pt;line-height: 150%;text-autospace:ideograph-numeric"><span
//                     style="font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:ArialMT">A
//                     Prestação de Contas Anual </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;font-family:&quot;Arial&quot;,sans-serif">do(a)
//                     ${this.certificado.dadosGerais.nmOrgao}</span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:ArialMT">,
//                     relativa ao exercício financeiro de ${this.PCAAtiva.dsAnoexercicio}, encontra-se constituída com as peças
//                     elencadas no Quadro I a seguir,
//                 </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">consoante dados
//                     informados no Sistema ÁGORA.</span></p>
//             <p class="Contedodetabela" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center"><span
//                     style="font-family: &quot;Arial&quot;,sans-serif">QUADRO 01 - ARQUIVOS DO PROCESSO ELETRÔNICO </span></p>
//             <table align="center" class="MsoNormalTable" style="margin-left:2.75pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:2.75pt 2.75pt 2.75pt 2.75pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr>
//                         <td style="width:59.7pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:2.75pt 2.75pt 2.75pt 2.75pt">
//                             <p class="Contedodetabela" style="margin-top:0cm;margin-right: 5.25pt;margin-bottom:0cm;margin-left:2.25pt;margin-bottom:.0001pt;text-align: center;line-height:10.0pt;layout-grid-mode:char"
//                                 align="center"><b style="mso-bidi-font-weight: normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">Módulo</span></b></p>
//                         </td>
//                         <td style="width:79.7pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:2.75pt 2.75pt 2.75pt 2.75pt">
//                             <p class="Contedodetabela" style="margin-top:0cm;margin-right: 5.25pt;margin-bottom:0cm;margin-left:2.25pt;margin-bottom:.0001pt;text-align: center;line-height:10.0pt;layout-grid-mode:char"
//                                 align="center"><b style="mso-bidi-font-weight: normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">Peça
//                                         Processual</span></b></p>
//                         </td>
//                         <td style="width:15.05pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:2.75pt 2.75pt 2.75pt 2.75pt">
//                             <p class="Contedodetabela" style="text-align:center;line-height: 10.0pt;layout-grid-mode:char" align="center"><b
//                                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">Enviada
//                                         ?</span></b></p>
//                         </td>
//                         <td style="width:15.05pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:2.75pt 2.75pt 2.75pt 2.75pt">
//                             <p class="Contedodetabela" style="text-align:center;line-height: 10.0pt;layout-grid-mode:char" align="center"><b
//                                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">Ausência
//                                         Justificada ?</span></b></p>
//                         </td>
//                     </tr>
//                     ${ this.tabela_pecas()}
//                 </tbody>
//             </table>
//             <p class="WW-Corpodetexto2" style="line-height:10.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;mso-bidi-font-weight:bold"></span></p>
//             <p class="WW-Corpodetexto2" style="text-align:center;line-height:10.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;mso-bidi-font-weight:bold" align="center">Fonte:
//                     Tribunal de Contas do Estado do Ceará - TCE / Sistema ÁGORA</span></p>
//             <p class="MsoNormal" style="margin-left:1.5pt;text-align:justify;text-indent: 69.0pt;mso-line-height-alt:10.0pt;tab-stops:2.25pt 12.3pt 49.65pt 85.45pt; text-autospace:ideograph-numeric"><b><span
//                         style="font-size:11.0pt;font-family: &quot;Arial&quot;,sans-serif;mso-fareast-font-family:ArialMT;background:yellow"></span></b></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.85pt;line-height: 150%"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:#00FF;mso-bidi-language:#00FF">O
//                     art. 4º da Instrução Normativa nº 01/2011 - TCE, editada por este Tribunal de Contas em 21 de junho de 2011, ao
//                     tratar da remessa do processo de Prestação de Contas Anual em meio eletrônico, exige que as peças processuais
//                     transmitidas devem receber a assinatura digital, segundo o padrão ICP-Brasil.</span></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.85pt;line-height: 150%;tab-stops:2.25pt 12.3pt 49.65pt 85.45pt;text-autospace:ideograph-numeric"><span
//                     style="font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF">O
//                     exame procedido por este Corpo Técnico verificou que os documentos listados foram enviados a esta Corte de
//                     Contas com as respectivas assinaturas digitais, conferindo ao documento eletromagnético autenticidade e
//                     integridade, confirmando sua autoria e completude. Logo, a presente Prestação de Contas Anual encontra-se em
//                     condição de ser considerada oficialmente recebida por este Tribunal.</span></p>
//             <p class="WW-Corpodetexto2" style="text-indent:71.25pt;mso-line-height-alt:10.0pt"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-fareast-font-family:ArialMT;mso-fareast-language: #00FF;mso-bidi-language:#00FF;font-weight:normal"></span></p>
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">3. ROL DOS RESPONSÁVEIS</span></b></p>
//             <p class="WW-BodyTextIndent3" style="text-indent:70.9pt;line-height:150%"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%">Consta
//                     no Quadro 2 o Rol dos Responsáveis pela </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%; mso-fareast-font-family:ArialMT">Prestação
//                     de Contas Anual do(a) ${this.certificado.dadosGerais.nmOrgao}, pertinente ao exercício de
//                     ${this.PCAAtiva.dsAnoexercicio}.</span></p>
//             <p class="WW-BodyTextIndent3" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center"><span
//                     style="font-size:10.0pt">QUADRO 02 - ROL DOS RESPONSÁVEIS</span></p>
//             <table align="center" class="MsoNormalTable" style="margin-left:2.75pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:2.75pt 2.75pt 2.75pt 2.75pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr>
//                         <td style="width:116.25pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="155">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Nome/Gestor</span></b></p>
//                         </td>
//                         <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="98">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">CPF</span></b></p>
//                         </td>
//                         <td style="width:99.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="133">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Categoria</span></b></p>
//                         </td>
//                         <td style="width:84.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="113">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Cargo</span></b></p>
//                         </td>
//                         <td style="width:56.25pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="75">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Início
//                                         da Gestão</span></b></p>
//                         </td>
//                         <td style="width:57.3pt;border:solid black 1.0pt;mso-border-alt: solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="76">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Fim
//                                         da Gestão</span></b><a name="TRbl_report_ConsultaProcessoEletronico0"></a></p>
//                         </td>
//                     </tr>
//                     ${ this.tabela_rol_certificado()}
//                 </tbody>
//             </table>
//             <p class="WW-Corpodetexto2" style="text-align:center;line-height:10.0pt" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-weight:normal">
//                     Fonte: Tribunal de Contas do Estado do Ceará - TCE / Sistema ÁGORA - Módulo Rol de Responsáveis.</span></p>
//             <p class="WW-Corpodetexto2" style="text-indent:72.75pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;mso-bidi-font-weight:bold">
//                 </span></p>
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">4. PROCESSOS CORRELATOS </span></b></p>
            
//             ${ this.tabela_processos_correlatos()}
            
//             <br />
//             <br />
            
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">5. CONTROLES INTERNOS </span></b>
//             </p>
//             <p class="Introducao" style="margin-top:0cm;text-indent:70.85pt;line-height:150%; tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial; mso-fareast-language:#00FF;mso-bidi-language:#00FF">
//                     Esta Gerência de Contas realizou análise dos controles internos do(a) ${ this.certificado.dadosGerais.nmOrgao},
//                     utilizando - se, para tanto, dos resultados advindos da
//                     aplicação de questionário de auto - avaliação de controles internos, respondido pelo referido Órgão.</span></p>
//             <p class="Introducao" style="margin-top:0cm;text-indent:70.85pt;line-height:150%; tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial; mso-fareast-language:#00FF;mso-bidi-language:#00FF">
//                     Ressalte - se que em relação a diversos aspectos do controle interno foi determinado que a entidade auditada
//                     deveria preencher o formulário com os valores de 1 a 4 de acordo com a validade da afirmativa no contexto do
//                     órgão, na seguinte correspondência: 1 = Nunca, 2 = Raramente, 3 = Com Frequência e 4 = Sempre.</span></p>
//             <p class="Introducao" style="margin-top:0cm;text-indent:70.85pt;line-height:150%; tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Calibri">
//                     Os resultados da análise estão apontados a seguir, conforme itens do questionário. Foram citados apenas os
//                     pontos cuja avaliação pela Gerência de Contas resultou na pontuação 1 ou 2, ou que a própria Companhia
//                     considerou como nunca ou raramente realizados.</span></p>
//             <p class="Introducao" style="margin-top:0cm;text-indent:0cm;line-height:150%; tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt; line-height:150%">
//                 </span></p>
//             <p class="Introducao" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:ArialMT;color:black;mso-fareast-language:#00FF; mso-bidi-language:#00FF">
//                     QUADRO 3 - AVALIAÇÃO DO CONTROLE INTERNO
//                 </span></p>
//             <table class="MsoNormalTable" style="margin-left:2.75pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:2.75pt 2.75pt 2.75pt 2.75pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr style="height:26.25pt">
//                         <td style="width:156.0pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="208">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Quesitos </span></b>
//                             </p>
//                         </td>
//                         <td style="width:156.0pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="208">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Pergunta </span></b>
//                             </p>
//                         </td>
//                         <td style="width:56.25pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="75">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Respostas
//                                     </span></b> </p>
//                         </td>
//                         <td style="width:54.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="72">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Avaliação do Analista </span></b>
//                             </p>
//                         </td>
//                         <td style="width:154.4pt;border:solid black 1.0pt;mso-border-alt: solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="206">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Parecer do Analista </span></b>
//                             </p>
//                         </td>
//                         <td style="width:65.25pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:26.25pt"
//                             width="87">
//                             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <b><span
//                                         style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                                         Plano de Ação
//                                     </span></b> </p>
//                         </td>
//                     </tr>
            
//                     ${ this.tabela_controle_interno()}
            
//                 </tbody>
//             </table>
            
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.85pt;line-height: 150%;mso-pagination:none;tab-stops:2.25pt 12.3pt 72.0pt 85.45pt;layout-grid-mode: char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:Mangal;mso-fareast-language:#00FF;mso-bidi-language: #00FF">
//                     Este órgão instrutivo, tendo em vista as deficiências acima expostas do controle interno </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%; font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial;mso-fareast-language: #00FF;mso-bidi-language:#00FF">do(a)
//                     ${this.certificado.dadosGerais.nmOrgao} </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-font-family:Mangal;mso-fareast-language:#00FF;mso-bidi-language: #00FF">,
//                     recomenda à sua <b> atual gestão </b> que </span> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family: Calibri;mso-ansi-language:#00FF;mso-fareast-language:#00FF;mso-bidi-language: #00FF">
//                     se manifeste acerca das deficiências elencadas no presente item, apresentando, caso sanadas,
//                     documentos que evidenciem tal situação ou, no caso de não sanadas ainda, as justificativas para tal, com um
//                     plano de ação para adoção de medidas cabíveis.</span></p>
//             <br />
//             <br />
            
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">
//                         6. CONTABILIDADE </span></b> </p>
//             ${this.tabela_contabilidade()}
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7. ORÇAMENTO
//                     </span></b> </p>
            
//             ${this.tabela_orcamento()}
            
//             <br />
//             <br />
            
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8. CONTRATOS
//                     </span></b> </p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.85pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family: Arial;mso-font-kerning:.5pt;mso-fareast-language:PT-BR;mso-bidi-language:PT-BR">
//                     Nas
//                     tipologias elaboradas
//                     pela Secretaria de
//                     Controle Externo -
//                     SECEX, foram
//                     verificadas ocorrências
//                     merecedoras de
//                     esclarecimento no que
//                     tange aos contratos e
//                     aditivos realizados no
//                     exercício sob exame.
//                 </span></p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:73.7pt;line-height: 150%;tab-stops:18.0pt 69.55pt;layout-grid-mode:char">
//                 <b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family: Arial;mso-fareast-language:PT-BR;mso-bidi-language:PT-BR">
//                     </span></b>
//             </p>
            
//             <p>
//             ${ this.tabela_contratos()}
//             </p>
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9. LICITAÇÕES
//                     </span></b>
//             </p>
            
//             ${this.tabela_licitacoes()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">10. TRANSFERÊNCIAS VOLUNTÁRIAS
//                     </span></b>
//             </p>
            
//             ${this.tabela_convenios()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">11. TOMADA DE CONTAS ESPECIAL
//                     </span></b>
//             </p>
            
//             ${this.tabela_tce()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12. CONTRATO DE GESTÃO
//                     </span></b>
//             </p>
            
//             ${this.tabela_cg()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13. GESTÃO DE MATERIAIS
//                     </span></b>
//             </p>
            
//             ${this.tabela_gm()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14. PESSOAL
//                     </span></b>
//             </p>
            
//             ${this.tabela_pessoal()}
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">15. MONITORAMENTO DAS DECISÕES
//                     </span></b>
//             </p>
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Neste item, tratam-se as recomendações e determinações expedidas pelo Tribunal em julgamentos de processos
//                     relativos a exercícios anteriores. Ressalta-se que a reincidência quanto ao descumprimento de determinação do
//                     Tribunal, poderá levar ao julgamento irregular das contas de gestão, conforme dispõe o §1º, do art. 15, da Lei
//                     nº 12.509/1995. Ademais, sujeita o gestor à multa prevista no art. 62, VIII, da Lei nº 12.509/95.</span></span>
//             </p>
            
//             <p class="WW-Recuodecorpodetexto2" style="margin-top:0cm;text-indent:70.85pt; tab-stops:35.4pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;mso-bidi-font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:ArialMT; mso-ansi-language:#00FF;mso-fareast-language:#00FF;mso-bidi-language:#00FF">
//                     ${this.tabela_monitoramento()}
//                 </span></p>
            
//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">16. OCORRÊNCIAS VERIFICADAS
//                     </span></b>
//             </p>
            
//             ${this.tabela_ocorrencias()}

//             <br />
//             <br />
//             <p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:70.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">17. CONCLUSÃO
//                     </span></b>
//             </p>
//             <p class="Introducao" style="margin-top:5.65pt;text-indent:70.5pt;line-height: 150%">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Diante do exposto, a Gerência de Contas de Gestão I, no uso de suas
//                     atribuições legais, conclui que a
//                 </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%; font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family:Arial">
//                     Prestação de Contas Anual do(a) ${this.certificado.dadosGerais.nmOrgao}
//                 </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-font-family: ArialMT">,
//                     pertinente ao ${ this.PCAAtiva.dsAnoexercicio},
//                 </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt; line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     apresentou os pontos relatados na presente instrução processual, sintetizados no item
//                     18, que merecem as devidas razões de justificaivas.</span></p>
//             <p class="Introducao" style="margin-top:0cm;text-indent:70.5pt;line-height:150%">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Na oportunidade, submete o feito à consideração superior desta Colenda Corte de Contas,
//                     sugerindo que seja procedida a <b> audiência </b> do responsável<a name="OLE_LINK1"></a>
//                     <a name="OLE_LINK2">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;mso-bookmark:OLE_LINK1">,
//                             a seguir citado, já devidamente qualificado no item
//                             3, para que apresente, no prazo determinado,
//                         </span>
//                     </a>
//                     os documentos e as justificativas necessárias acerca das ocorrências apontadas no presente
//                     Certificado, resguardando o direito expresso no art. 5º, LV, da Constituição Federal:
//                 </span></p>
//             <p class="MsoNormal" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif">
//                     QUADRO 07 - RESPONSÁVEL POR OCORRÊNCIAS
//                 </span></p>
            
//             <table class="MsoNormalTable" style="margin-left:2.75pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:2.75pt 2.75pt 2.75pt 2.75pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr>
//                         <td style="width:116.25pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="155">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Nome/Gestor</span></b></p>
//                         </td>
//                         <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="98">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">CPF</span></b></p>
//                         </td>
//                         <td style="width:99.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="133">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Categoria</span></b></p>
//                         </td>
//                         <td style="width:84.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="113">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Cargo</span></b></p>
//                         </td>
//                         <td style="width:56.25pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="75">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Início
//                                         da Gestão</span></b></p>
//                         </td>
//                         <td style="width:57.3pt;border:solid black 1.0pt;mso-border-alt: solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="76">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Fim
//                                         da Gestão</span></b><a name="TRbl_report_ConsultaProcessoEletronico0"></a></p>
//                         </td>
//                     </tr>
//                     ${ this.tabela_rol_certificado()}
//                 </tbody>
//             </table>
            
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 225.6pt 288.0pt;background:white">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Caso não seja possível a comprovação da ciência pessoal dos aludidos responsáveis, seja autorizada desde já e
//                     sucessivamente, com base nos princípios da eficiência e da economia processual, a repetição das referidas
//                     notificações por meio das modalidades "mão própria" e edital, esta última com publicação no Diário Oficial do
//                     Estado do Ceará (DOE/CE), conforme previsto no art. 21, parágrafo único, da Lei Estadual nº 12.509/95.
//                 </span></p>
//             <p class="MsoNormal" style="margin-top:5.65pt;text-align:justify;text-indent: 70.5pt;line-height:150%;tab-stops:18.0pt 225.6pt 288.0pt;background:white">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:#00FF;mso-bidi-language:#00FF">
//                     Gerência de Contas de Gestão I da Secretaria de Controle Externo do Tribunal de Contas do Estado do Ceará.
//                     Fortaleza, ${ this.dataGeracao}.
//                 </span></p>
            
//             <p class="WW-Recuodecorpodetexto31" style="margin-left:0cm;text-indent:0cm; line-height:150%">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%;mso-fareast-language: #00FF;mso-bidi-language:#00FF;mso-bidi-font-weight:bold">
//                     Assinam digitalmente este documento:
//                 </span></p>`;

//             this.loading = false;
//             console.log("Fim certificado");
//             //}
//         }, error => {
//             console.log("erro: " + error);
//             this.alertService.mostraAlerta("", "Houve um erro no carregamento do Certificado.");
//             this.loading = false;
//         });
//     }

//     cpf_mask(v) {
//         v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
//         v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
//         v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
//         //de novo (para o segundo bloco de números)
//         v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
//         return v;
//     }

//     compare(a, b) {
//         // Use toUpperCase() to ignore character casing
//         const moduloA = a.dsModulo.toUpperCase();
//         const moduloB = b.dsModulo.toUpperCase();

//         let comparison = 0;
//         if (moduloA > moduloB) {
//             comparison = 1;
//         } else if (moduloA < moduloB) {
//             comparison = -1;
//         }
//         return comparison;
//     }

//     tabela_pecas() {
//         let table = "";
//         let enviado = "";
//         let justificado = "";

//         this.certificado.pecas.sort(this.compare).forEach(peca => {

//             if (peca.flPossuiArquivo) {
//                 enviado = "Sim";
//             } else {
//                 enviado = "Não";
//             }

//             if (peca.flPossuiJustificativa) {
//                 justificado = "Sim";
//             } else {
//                 justificado = "Não";
//             }

//             table += `<tr>
//                         <td style="width:118.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="200">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         ${ peca.dsModulo} </span></span> </p>
//                         </td>
//                         <td style="width:136.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="350">
//                             <p class="Contedodatabela0" style="margin-left:2.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     ${ peca.nmTipoDocumento}
//                                 </span></p>
//                         </td>
//                         <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="67" align="center">
//                             <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${ enviado} </span></p>
//                         </td>
//                         <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="67" align="center">
//                             <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${ justificado} </span></p>
//                         </td>                        
//                     </tr>`;
//         });

//         return table;
//     }

//     // ok
//     //#region Sprint 1
//     tabela_rol_certificado() {
//         let table = "";

//         this.certificado.rolResponsaveis.forEach(rol => {

//             if (rol.listaPessoaFuncao && rol.listaPessoaFuncao.length > 0) {
//                 rol.listaPessoaFuncao.forEach(pessoaFuncao => {
//                     pessoaFuncao.listaPeriodoFuncao.forEach(periodoFuncao => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="155">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         ${ pessoaFuncao.pessoa.nomePessoa} </span></span> </p>
//                         </td>
//                         <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="98">
//                             <p class="Contedodatabela0" style="margin-left:2.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     ${ this.cpf_mask(pessoaFuncao.pessoa.cpf)}
//                                 </span></p>
//                         </td>
//                         <td style="width:99.75pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="133">
//                             <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${
//                             rol.dsFuncao} </span></p>
//                         </td>
//                         <td style="width:84.75pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="113">
//                             <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${
//                             pessoaFuncao.cargo.nomeCargo} </span></p>
//                         </td>
//                         <td style="width:56.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="75">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     ${ periodoFuncao.dataInicio}
//                                 </span></p>
//                         </td>
//                         <td style="width:57.3pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .25pt;mso-border-bottom-alt:solid black .25pt; mso-border-right-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="76">
//                             <p class="Contedodatabela0" style="text-align:center" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     ${ periodoFuncao.dataFim}
//                                 </span><a name="TRbl_report_ConsultaProcessoEletronico21"></a> </p>
//                         </td>
//                     </tr>`
//                     });
//                 });
//             }
//         });

//         return table;
//     }

//     tabela_processos_correlatos() {
//         let table = "";

//         if (this.certificado.lstProcessosCorrelatos && this.certificado.lstProcessosCorrelatos.length > 0) {

//             table += `<p class="WW-BodyTextIndent3" style="text-indent:70.9pt;line-height:150%"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%">Consta
// no Quadro 2 o Rol dos Responsáveis pela </span><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height:150%; mso-fareast-font-family:ArialMT">Prestação
// de Contas Anual do(a) ${this.certificado.dadosGerais.nmOrgao}, pertinente ao exercício de
// ${this.PCAAtiva.dsAnoexercicio}.</span></p>
// <p class="WW-BodyTextIndent3" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center"><span
// style="font-size:10.0pt">QUADRO 02 - ROL DOS RESPONSÁVEIS</span></p>
// <table align="center" class="MsoNormalTable" style="margin-left:2.75pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:2.75pt 2.75pt 2.75pt 2.75pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr>
//     <td style="width:116.25pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="155">
//         <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Nº
//                     do Processo</span></b></p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="98">
//         <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Órgão/Entidade</span></b></p>
//     </td>
//     <td style="width:99.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="133">
//         <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Espécie</span></b></p>
//     </td>
//     <td style="width:84.75pt;border:solid black 1.0pt;border-right: none;mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="143">
//         <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Assunto</span></b></p>
//     </td>
//     <td style="width:56.25pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .25pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;background:#CCCCCC;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="105">
//         <p class="Contedodatabela0" style="text-align:center" align="center"><b><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">Situação</span></b></p>
//     </td>
// </tr>`;

//             this.certificado.lstProcessosCorrelatos.forEach(processoCorrelato => {

//                 table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                                 width="155">
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                             ${ processoCorrelato.nrProcesso} </span></span> </p>
//                             </td>
//                             <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                                 width="98">
//                                 <p class="Contedodatabela0" style="margin-left:2.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         ${ processoCorrelato.entidade}
//                                     </span></p>
//                             </td>
//                             <td style="width:99.75pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                                 width="133">
//                                 <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${processoCorrelato.especie} </span></p>
//                             </td>
//                             <td style="width:84.75pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                                 width="143">
//                                 <p class="Contedodatabela0"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif"> ${processoCorrelato.assunto} </span></p>
//                             </td>
//                             <td style="width:56.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                                 width="105">
//                                 <p class="Contedodatabela0" style="text-align:center" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         ${ processoCorrelato.situacaoCorrelato}
//                                     </span></p>
//                             </td>
//                         </tr>`;
//             });

//             table += `</tbody>
//             </table>`;
//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//         De
//         acordo com os registros no Sistema de Acompanhamento de Processos - SAP, não existe processo correlato de representação no âmbito do(a)
//         ${ this.certificado.dadosGerais.nmOrgao}.</span></p>
// <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }

//     tabela_controle_interno() {
//         let table = "";

//         this.certificado.lstrQuestoesCertificado.forEach(questao => {
//             questao.perguntas.forEach(pergunta => {
//                 table += `<tr style="height:62.3pt">
//             <td style="width:156.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//                 width="208">
//                 <p class="MsoNormal" style="text-align:justify;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                     ${questao.dsCategoriaQuestao}    
//                     </span></p>
//             </td>
//             <td style="width:156.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//                 width="208">
//                 <p class="MsoNormal" style="text-align:justify;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                     ${pergunta.titulo}    
//                     </span></p>
//             </td>
//             <td style="width:56.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//                 width="75">
//                 <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                         ${pergunta.resposta.valor} (${pergunta.resposta.dsValor}) 
//                         </span></p>
//             </td>          
//             <td style="width:54.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//                 width="72">
//                 <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                 ${pergunta.analista.valor} (${pergunta.analista.dsValor})        
//                 </span></p>
//             </td>
//             <td style="width:154.4pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .25pt;mso-border-bottom-alt:solid black .25pt; mso-border-right-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//                 width="206">
//                 <p class="MsoNormal" style="text-align:justify;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//                         ${pergunta.analista.dsRespAnalista}
//                         </span></p>
//             </td>
//             <td style="width:65.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt; height:62.3pt"
//             width="87">
//             <p class="Contedodetabela" style="text-align:center;layout-grid-mode: char" align="center"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:9.0pt">
//             Início: ${pergunta.dtPlanoInicio} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Fim: ${pergunta.dtPlanoFim}<br>
//             Ações: ${pergunta.dsPlanoAcao}</span></p>
//         </td>
//         </tr>`;
//             });
//         });

//         return table;
//     }
//     //#endregion

//     //#region Sprint 2
//     tabela_contabilidade() {
//         let table = "";

//         if (this.certificado.contabilidadeCertificadoWrapper) {


//             if (!this.certificado.contabilidadeCertificadoWrapper.isIndependente) {

//                 // #region Análise Horizontal
//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.1. Análise Horizontal do Balanço Financeiro
//                 </span></b> </p>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise horizontal do Balanço
//             Financeiro.
//             <br />
//             <br /> As tabelas a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Ingressos
//                         </span>
// </p>
// <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso) {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita) {
//                                     table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.gruposPrimarios) {
//                                         this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anIngresso.receita.gruposPrimarios.forEach(analise => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                             if (analise.secundarios) {
//                                                 analise.secundarios.forEach(analise2 => {
//                                                     table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     if (analise2.terciarios) {
//                                                         analise2.terciarios.forEach(analise3 => {
//                                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;
//                                                         });
//                                                     }
//                                                 });
//                                             }
//                                         });


//                                     }
//                                 }
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             dos Ingressos existentes no Balanço Financeiro.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                         table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Dispêndio
//                                             </span>
//                     </p>
//                     <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Exercício Atual
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Exercício Anterior
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Variação </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio) {
//                                 table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.dcValorExercicioAtual)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.dcValorExercicioAnterior)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.dcVariacao)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa) {
//                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.gruposPrimarios) {
//                                         this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.anDispenio.despesa.gruposPrimarios.forEach(analise => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analise.secundarios) {
//                                                 analise.secundarios.forEach(analise2 => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise2.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise2.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                     if (analise2.terciarios) {
//                                                         analise2.terciarios.forEach(analise3 => {
//                                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise3.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise3.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;
//                                                         });
//                                                     }
//                                                 });
//                                             }
//                                         });


//                                     }
//                                 }
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//                                 dos Dispêndios existentes no Balanço Financeiro.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoFinanceiro.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.2. Análise Horizontal do Balanço Patrimonial
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise horizontal do Balanço
//             Patrimonial.
//             <br />
//             <br /> As tabelas a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             dos Ingressos existentes no Balanço Patrimonial.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatrimonial.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.3. Análise Horizontal do Balanço DVP
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise horizontal do Balanço
//             DVP.
//             <br />
//             <br /> As tabelas a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.variacoes) {
//                                     analise.variacoes.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.grupoVariacoes) {
//                                             analise1.grupoVariacoes.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             da DVP.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDVP.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.4. Análise Horizontal da DFC
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise horizontal da DFC.
//             <br />
//             <br /> As tabelas a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.gruposPrimarios) {
//                                     analise.gruposPrimarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalDFC.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }
//                 // #endregion

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.5. Análise Vertical do Balanço Patrimonial
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise horizontal do Balanço
//             Patrimonial.
//             <br />
//             <br /> As tabelas a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             dos Ingressos existentes no Balanço Patrimonial.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonial.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 // tabela unica
//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.5. Contas Bancárias
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise das Contas Bancárias.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias.analises.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Banco
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Agência
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Conta </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Fonte da Diferença
//     </span></b>
//     </p>
//     </td>          
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias.analises.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.banco} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.agencia}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.conta}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.fonte}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseContasBancarias.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.7. Saldos Bancários Declarados
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise dos Saldos Bancários
//             Declarados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dados Bancários
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Comparação Realizada
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo Declarado
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo SIAFE </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo Extrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>        
// </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises.forEach(analise => {
//                             table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Banco: </b> ${ analise.banco}
//                 <br />
//                 <b>Agência: </b> ${ analise.agencia}
//                 <br />
//                 <b>Conta: </b> ${ analise.conta} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.indicaComparacao(analise)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoConta)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoS2GPR)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoExtrato)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(this.calcularDiferenca(analise))}
// </span></span> </p>
// </td>

// </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 // tabela unica sem loop
//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.8. Previsão Inicial das Contas Analíticas
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise da previsão inicial
//             das Contas Analíticas.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Extratos Declarados
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Caixa e Equivalente de Caixa
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosPca)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosBalancoPatrimonial)} 
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.divergenciaSaldoExtratos)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.9. Saldo das Contas Analíticas
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise das Contas Analíticas.
//     <br />
//     <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas.analises.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo Balanço Orçamentário
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo DW </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença
//     </span></b>
//     </p>
//     </td>          
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas.analises.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.descricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.saldoBalanco)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.saldoDw)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseSaldoContasAnaliticas.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.10. Receita Orçamentária Ordinária X Receita Orçamentária Vinculada
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado o comparativo entre as receitas
//             orçamentárias ordinária e vinculada.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas.analises.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo Balanço Orçamentário
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo DW </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença
//     </span></b>
//     </p>
//     </td>          
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas.analises.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.descricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.valorArq)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.valorDw)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Não foram identificadas inconsistências relacionadas a este item.
//     </span>
//     </p>
//     <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseReceitasOrdinariasVsVinculadas.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.11. Total de Restos a Pagar Processados
//                 </span></b> </p>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.analises) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada análise sobre o total de restos
//             a pagar processados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Empenhado
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Relatório
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença (R$) </span> </b> </p>
// </td>      
// </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.analises) {
//                                 this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.analises.forEach(analise => {
//                                     table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.descricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalEmpenhoPago)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalRelatorio)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                     if (analise.analisesTipos) {
//                                         analise.analisesTipos.forEach(analisePrimaria => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analisePrimaria.descricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalEmpenhoPago)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalRelatorio)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analisePrimaria.diferenca)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;
//                                         });
//                                     }
//                                 });
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             dos Ingressos existentes no Balanço Financeiro.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarProcessados.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.12. Total de Restos a Pagar Não-Processados
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada análise sobre o total de restos
//             a pagar não-processados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados.analises.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Total Empenhado
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Total no Balanço </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$)
//     </span></b>
//     </p>
//     </td>          
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados.analises.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.descricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.totalEmpenho)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.totalAnexo)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Não foram identificadas inconsistências relacionadas a este item.
//     </span>
//     </p>
//     <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseTotalRestosPagarNaoProcessados.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.13. Execução de Restos a Pagar Não-Processados
//                 </span></b> </p>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.analises) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada análise sobre a execução de
//             restos a pagar não-processados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Empenhado
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total no Balanço
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença (R$) </span> </b> </p>
// </td>      
// </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.analises) {
//                                 this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.analises.forEach(analise => {
//                                     table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.descricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalEmpenho)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalAnexo)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                     if (analise.analiseExecucaoRestosPagarNaoProc) {
//                                         analise.analiseExecucaoRestosPagarNaoProc.forEach(analisePrimaria => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analisePrimaria.descricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalEmpenho)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalAnexo)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analisePrimaria.diferenca)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;
//                                         });
//                                     }
//                                 });
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagarNaoProc.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.14. Execução de Restos a Pagar Processados x Não processados Liquidados
//                 </span></b> </p>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.analises) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado comparativo entre a execução
//             de restos a pagar não-processados e os não processados liquidados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td rowspan="1" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td>
// <tr>
// <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Restos a Pagar Processados
// </span></b>
// </p>
// </td>
// </tr>
// <tr>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total no SIAFE
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total no Anexo </span> </b> </p>
// </td> 
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença (R$) </span> </b> </p>
// </td> 
// </tr>
// </td>

// <td>
// <tr>
// <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Restos a Pagar Não Processados
// </span></b>
// </p>
// </td>
// </tr>
// <tr>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total no SIAFE
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total no Anexo </span> </b> </p>
// </td> 
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença (R$) </span> </b> </p>
// </td> 
// </tr>
// </td>
     
// </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.analises) {
//                                 this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.analises.forEach(analise => {
//                                     table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.descricao} </span></span> </p>               
//     </td>
//     <td>
//     <tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalProcessado)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalRelatorioProc)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.diferencaProcessado)}
//     </span></span> </p>
//     </td>
//     </tr>
//     </td>

//     <td>
//     <tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalEmpenho)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.totalAnexo)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.diferenca)}
//     </span></span> </p>
//     </td>
//     </tr>
//     </td>
    
//     </tr>`;

//                                     if (analise.analises) {
//                                         analise.analises.forEach(analisePrimaria => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analisePrimaria.descricao} </span></span> </p>               
//         </td>
//         <td>
//         <tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalProcessado)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalRelatorioProc)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analisePrimaria.diferencaProcessado)}
//         </span></span> </p>
//         </td>
//         </tr>
//         <td>

//         <td>
//         <tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalEmpenho)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analisePrimaria.totalAnexo)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analisePrimaria.diferenca)}
//         </span></span> </p>
//         </td>
//         </tr>
//         <td>
        
//         </tr>`;
//                                         });
//                                     }
//                                 });
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosAPagarLiquidadosDespesa.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 // continuando

//                 if (this.certificado.contabilidadeCertificadoWrapper.indicadores) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.15. Indicadores
//                 </span></b> </p>`;

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Execução da Receita
//                         </span>
// </p>
// <br/>`;

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').length > 0)) {

//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Previsão Atualizada
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Receita Realizada
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').valor2)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').valor1)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').percentual)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_RECEITA').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analisePrimaria.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analisePrimaria.valor2)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analisePrimaria.valor1)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analisePrimaria.percentual)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analiseSecundaria.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analiseTerciaria.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Sem análises para apresentar.
//                                         </span>
//                 </p>
//                 <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }



//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Execução da Despesa
//                                             </span>
//                     </p>
//                     <br/>`;

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Dotação Atualizada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesa Empenhada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Variação </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_EXECUCAO_DESPESA').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Não foram identificadas inconsistências relacionadas a este item.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Despesas e Replanejamento
//                                             </span>
//                     </p>
//                     <br/>`;

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Aplicações com Custeio
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesa Empenhada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Índice Despesas Correntes </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_CORRENTE').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Aplicações com Investimento
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesa Empenhada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Índice Despesas com Investimento </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_DESPESA_INVESTIMENTO').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Receita Realizada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Previsão Atualizada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Índice de Replanejamento </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_REPLANEJAMENTO').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Resto à Pagar
//                                             </span>
//                     </p>
//                     <br/>`;

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesa Empenhada
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Restos à Pagar
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Percentual </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesas Empenhadas
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Restos a Pagar Processados
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Percentual </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_PROCESSADOS').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                     if ((this.certificado.contabilidadeCertificadoWrapper.indicadores.analises) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS')) && (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').length > 0)) {


//                         if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Despesas Empenhadas
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Restos a Pagar Não Processados
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Percentual </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').lstIndicadores1) {
//                                 this.certificado.contabilidadeCertificadoWrapper.indicadores.analises.find(a => a.tipoIndice === 'INDICE_INSCRICAO_RESTO_PAGAR_NAO_PROCESSADOS').lstIndicadores1.forEach(analisePrimaria => {
//                                     table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${analisePrimaria.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor1)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(analisePrimaria.valor2)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(analisePrimaria.percentual)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                     if (analisePrimaria.lstIndicadores2) {
//                                         analisePrimaria.lstIndicadores2.forEach(analiseSecundaria => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseSecundaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseSecundaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseSecundaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analiseSecundaria.lstIndicadores3) {
//                                                 analiseSecundaria.lstIndicadores3.forEach(analiseTerciaria => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analiseTerciaria.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor1)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analiseTerciaria.valor2)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analiseTerciaria.percentual)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                 });
//                                             }
//                                         });
//                                     }


//                                 });
//                             } else {
//                                 table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                             }

//                             table += `</tbody></table>`;
//                         }

//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Sem análises para apresentar.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }


//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.indicadores.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.indicadores.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.16. Balanço Financeiro x Balanço Patrimonial
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado comparativo entre o Balanço
//     Financeiro e o Balanço Patrimonial.
//     <br />
//     <br /> A tabela a seguir demonstra este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.divergenciaValorCaixa) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Balanço Patrimonial
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Balanço Financeiro
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.caixaEquivalenteBalancoPatdimonial)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.caixaEquivalenteBalancoFinanceiro)} 
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.divergenciaValorCaixa)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseBalancoCaixa.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.17. Análise de Caixa e Equivalente de Caixa
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise de Caixa e Equivalente de Caixa.
//     <br />
//     <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Extratos Declarados
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Caixa e Equivalente de Caixa
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosPca)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosBalancoPatrimonial)} 
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.divergenciaSaldoExtratos)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.18. Execução de Restos a Pagar x Restos a Pagar Processados/Não Processados
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado o comparativo entre a execução
//             dos restos a pagar e os restos a pagar processados/não processados.
//             <br />
//             <br /> A tabela a seguir demonstra este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>

//     <tr style="height:15.0pt">
//     <td colspan="4" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Anterior
//     </span></b>
//     </p>
//     </td>
//     <td colspan="4" style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Atual
//     </span></b>
//     </p>
//     </td>            
//     </tr>


//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Anterior
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Processado
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Não Processado
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>

//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Atual
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Processado
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Não Processado
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.exercRestosPagarValorExercicioAnterior)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.restosPagarProcessadoAnterior)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.restosPagarNaoProcessadoAnterior)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.divergenciaValorExercicioAnterior)} 
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.exercRestosPagarValorExercicioAtual)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.restosPagarProcessadoAtual)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.restosPagarNaoProcessadoAtual)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.analiseRestoPagar.divergenciaValorExercicioAtual)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     } else {
//                         table += `
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Não foram identificadas inconsistências relacionadas a este item.
//     </span>
//     </p>
//     <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExecucaoRestosPagar.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.19. Execução de Valores Restituíveis x Valores Restituíveis
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à composição e gastos com pessoal no exercício em análise.
//             <br />
//             <br /> O gráfico a seguir demonstra a composição dos gastos.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>

//     <tr style="height:15.0pt">
//     <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Anterior
//     </span></b>
//     </p>
//     </td>
//     <td colspan="3" style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Atual
//     </span></b>
//     </p>
//     </td>            
//     </tr>


//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Para Execução de Valores Restituíveis
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Restituível
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>

//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Para Execução de Valores Restituíveis
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Restituível
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.exercValorRestituivelExercicioAnterior)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.valorRestituivelAnterior)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.divergenciaValorRestituivelAnterior)} 
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.exercValorRestituivelExercicioAtual)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.valorRestituivelAtual)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.analiseValoresRestituiveis.divergenciaValorRestituivelAtual)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     } else {
//                         table += `
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Não foram identificadas inconsistências relacionadas a este item.
//     </span>
//     </p>
//     <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseValoresRestituiveis.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.20. Saldo em Espécie do Exercício Anterior x Saldo em Espécie para o Exercício Seguinte
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à composição e gastos com pessoal no exercício em análise.
//             <br />
//             <br /> O gráfico a seguir demonstra a composição dos gastos.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>

//     <tr style="height:15.0pt">
//     <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Anterior
//     </span></b>
//     </p>
//     </td>
//     <td colspan="3" style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="50%">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Exercício Atual
//     </span></b>
//     </p>
//     </td>            
//     </tr>


//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Para Execução de Valores Restituíveis
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Restituível
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>

//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Para Execução de Valores Restituíveis
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Valor Restituível
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.exercValorRestituivelExercicioAnterior)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.valorRestituivelAnterior)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.divergenciaValorRestituivelAnterior)} 
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.exercValorRestituivelExercicioAtual)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.valorRestituivelAtual)} 
//     </span></span> </p>
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.analiseSaldosEspecieModel.divergenciaValorRestituivelAtual)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     } else {
//                         table += `
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Não foram identificadas inconsistências relacionadas a este item.
//     </span>
//     </p>
//     <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseSaldoEmEspecie.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 // #region Validação de Consistência Entre os Exercícios
//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.21. Validação de Consistência Entre os Exercícios do Balanço Patrimonial
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado o comparativo entre os exercícios
//             do Balanço Patrimonial.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.22. Validação de Consistência Entre os Exercícios do Balanço Financeiro
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado o comparativo entre os exercícios
//             do Balanço Financeiro.
//             <br />
//             <br /> A tabela a seguir demonstra este resultado.
//                         </span>
// </p>
// <br/>`;


// table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Ingressos
//                         </span>
// </p>
// <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso) {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita) {
//                                     table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.gruposPrimarios) {
//                                         this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anIngresso.receita.gruposPrimarios.forEach(analise => {
//                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                             if (analise.secundarios) {
//                                                 analise.secundarios.forEach(analise2 => {
//                                                     table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     if (analise2.terciarios) {
//                                                         analise2.terciarios.forEach(analise3 => {
//                                                             table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;
//                                                         });
//                                                     }
//                                                 });
//                                             }
//                                         });


//                                     }
//                                 }
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//             dos Ingressos existentes no Balanço Financeiro.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                         table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Dispêndio
//                                             </span>
//                     </p>
//                     <br/>`;

//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Descrição
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Exercício Atual
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Exercício Anterior
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Variação </span> </b> </p>
//                     </td>      
//                     </tr>`;

//                             if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio) {
//                                 table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.dsDescricao} </span></span> </p>               
//                         </td>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="180">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.dcValorExercicioAtual)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.dcValorExercicioAnterior)}
//                         </span></span> </p>
//                         </td>
                        
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.dcVariacao)}
//                         </span></span> </p>
//                         </td>
                        
//                         </tr>`;

//                                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa) {
//                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.gruposPrimarios) {
//                                         this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.anDispenio.despesa.gruposPrimarios.forEach(analise => {
//                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                             if (analise.secundarios) {
//                                                 analise.secundarios.forEach(analise2 => {
//                                                     table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise2.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise2.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;

//                                                     if (analise2.terciarios) {
//                                                         analise2.terciarios.forEach(analise3 => {
//                                                             table += `<tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${analise3.dsDescricao} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="180">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//                             </span></span> </p>
//                             </td>
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="80">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             ${this.formatarPorcentagem(analise3.dcVariacao)}
//                             </span></span> </p>
//                             </td>
                            
//                             </tr>`;
//                                                         });
//                                                     }
//                                                 });
//                                             }
//                                         });


//                                     }
//                                 }
//                             }


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     No presente tópico, a partir das informações prestadas pelo jurisdicionado, não foi possível realizar a análise horizontal
//                                 dos Dispêndios existentes no Balanço Financeiro.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoFinanceiro.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 // #endregion
//             }

//             if (!this.certificado.contabilidadeCertificadoWrapper.isIndependente && this.certificado.contabilidadeCertificadoWrapper.isSefaz) {

//             }

//             // OK
//             if (this.certificado.contabilidadeCertificadoWrapper.isIndependente && this.certificado.contabilidadeCertificadoWrapper.isDependente) {

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.5. Análise Horizontal do Balanço Patrimonial - SPED
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à análise horizontal do Balanço Patrimonial relativo ao SPED.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.2. Análise Vertical do Balanço Patrimonial - SPED
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à análise vertical do Balanço Patrimonial relativo ao SPED.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Atual no Grupo </span> </b> </p>
// </td> 
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Anterior no Grupo </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcParticipacaoAtual)}
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcParticipacaoAnterior)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcParticipacaoAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcParticipacaoAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }
//             }

//             // OK
//             if (this.certificado.contabilidadeCertificadoWrapper.isIndependente) {

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.1. Saldos Bancários Declarados
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise dos Saldos Bancários
//             Declarados.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;

//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dados Bancários
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Comparação Realizada
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo Declarado
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo SIAFE </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo Extrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>        
// </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.analises.forEach(analise => {
//                             table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Banco: </b> ${ analise.banco}
//                 <br />
//                 <b>Agência: </b> ${ analise.agencia}
//                 <br />
//                 <b>Conta: </b> ${ analise.conta} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.indicaComparacao(analise)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoConta)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoS2GPR)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoExtrato)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(this.calcularDiferenca(analise))}
// </span></span> </p>
// </td>

// </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseSaldosDeclarados.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.2. Análise Vertical do Balanço Patrimonial - SPED
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à análise vertical do Balanço Patrimonial relativo ao SPED.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Atual no Grupo </span> </b> </p>
// </td> 
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Anterior no Grupo </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcParticipacaoAtual)}
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcParticipacaoAnterior)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise1.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcParticipacaoAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcParticipacaoAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcParticipacaoAtual)}
//         </span></span> </p>
//         </td>

//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseVerticalBalancoPatrimonialSped.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.3. Validação das Contas Totalizadoras do Balanço Patrimonial - SPED
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//     à validação das contas totalizadoras do Balanço Patrimonial relativo ao SPED.

//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP.demonstracoes) && (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP.demonstracoes.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Conta
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo Conta Totalizadora </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Somatório Contas Analíticas
//     </span></b>
//     </p>
//     </td>   
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$)
//     </span></b>
//     </p>
//     </td>       
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP.demonstracoes.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.idConta} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.dsDescricao}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcSaldoContaTotalizadora)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcSomatorioContasAnaliticas)}
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcDiferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP.dsResultado) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP.dsResultado}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedBP) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.4. Validação das Contas Totalizadoras da Demonstração de Resultado do Exercício - SPED
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à validação das contas totalizadoras da Demonstração de Resultado do Exercício relativo ao SPED.

//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedDRE.demonstracoes) && (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedDRE.demonstracoes.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Conta
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo Conta Totalizadora </span> </b> </p>
//     </td>
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Somatório Contas Analíticas
//     </span></b>
//     </p>
//     </td>   
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$)
//     </span></b>
//     </p>
//     </td>       
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedDRE.demonstracoes.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.idConta} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.dsDescricao}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcSaldoContaTotalizadora)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcSomatorioContasAnaliticas)}
//     </span></span> </p>
//     </td>

//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.dcDiferenca)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedDRE.dsResultado) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseValidacaoContasTotalizadorasSpedDRE.dsResultado}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.5. Análise Horizontal do Balanço Patrimonial - SPED
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//             à análise horizontal do Balanço Patrimonial relativo ao SPED.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseHorizontalBalancoPatSped.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.6. Validação de Consistência Entre os Exercícios do Balanço Patrimonial
//                 </span></b> </p>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.length > 0)) {

//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrado o comparativo entre os exercícios
//             do Balanço Patrimonial.
//             <br />
//             <br /> A tabela a seguir demonstram este resultado.
//                         </span>
// </p>
// <br/>`;


//                         if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.length > 0) {
//                             table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação </span> </b> </p>
// </td>      
// </tr>`;

//                             this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.analises.forEach(analise => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${analise.dsDescricao} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAtual)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarValorNumerico(analise.dcValorExercicioAnterior)}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${this.formatarPorcentagem(analise.dcVariacao)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;

//                                 if (analise.primarios) {
//                                     analise.primarios.forEach(analise1 => {
//                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAtual}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise1.dcValorExercicioAnterior}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise1.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                         if (analise1.secundarios) {
//                                             analise1.secundarios.forEach(analise2 => {
//                                                 table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise2.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise2.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise2.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                 if (analise2.terciarios) {
//                                                     analise2.terciarios.forEach(analise3 => {
//                                                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${analise3.dsDescricao} </span></span> </p>               
//         </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAtual)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarValorNumerico(analise3.dcValorExercicioAnterior)}
//         </span></span> </p>
//         </td>
        
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${this.formatarPorcentagem(analise3.dcVariacao)}
//         </span></span> </p>
//         </td>
        
//         </tr>`;

//                                                     });
//                                                 }
//                                             });
//                                         }
//                                     });
//                                 }


//                             });


//                             table += `</tbody></table>`;
//                         } else {
//                             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                         }

//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Não foram identificadas inconsistências relacionadas a este item.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.resultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseExercicioBalancoPatrimonial.resultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                 </p>`;
//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.7. Análise da Inversão de Saldos no Balanço Patrimonial
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais pontos relacionados
//     à análise da consistência dos saldos de acordo com a natureza das contas (devedora ou credora) no Balanço Patrimonial.
//     </span>
//     </p>
//     <br/>`;


//                     if ((this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED.analises) && (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED.analises.length > 0)) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Descrição
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Saldo
//     </span></b>
//     </p>
//     </td>
        
//     </tr>`;

//                         this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED.analises.forEach(analise => {
//                             table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ analise.dsConta} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(analise.saldoConta)}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED.dsResultado) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseSaldosViradosSPED.dsResultado}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }

//                 if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos) {
//                     table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">6.8. Análise de Caixa e Equivalente de Caixa
//                     </span></b> </p>
    
//     <br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     No presente tópico, a partir das informações prestadas pelo jurisdicionado, está demonstrada a análise de Caixa e Equivalente de Caixa.
//     <br />
//     <br /> A tabela a seguir demonstram este resultado.
//     </span>
//     </p>
//     <br/>`;


//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos) {


//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//     <tr style="height:15.0pt">
//     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="80">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Extratos Declarados
//     </span></b>
//     </p>
//     </td>
//     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="120">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Caixa e Equivalente de Caixa
//     </span></b>
//     </p>
//     </td>
//     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//     width="100">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//     Diferença (R$) </span> </b> </p>
//     </td>
            
//     </tr>`;

//                         table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosPca)} 
//     </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.saldoExtratosBalancoPatrimonial)} 
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="100">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ this.formatarValorNumerico(this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.analiseSaldoExtratos.divergenciaSaldoExtratos)} 
//     </span></span> </p>
//     </td>
//     </tr>`;

//                         table += `</tbody></table>`;
//                     }

//                     table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                     style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                     </span></b> </p>
//                     <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                     if (this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise) {
//                         table += `${this.certificado.contabilidadeCertificadoWrapper.analiseBalancoSaldoExtratos.dsResultadoAnalise}`;
//                     } else {
//                         table += `O parecer do analista não foi preenchido.`;
//                     }
//                     table += `</span>
//                     </p>`;

//                 }
//             }
//         }

//         return table;
//     }

//     tabela_orcamento() {
//         let table = `<br />
//         <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//         A execução orçamentária, alusivo ao exercício em análise, contempla as verificações concernentes a Dotação
//             Inicial, Despesas Orçamentárias, Metas físicas e Financeiras, Despesas Exercício Anteriores e Aplicação de
//             Recursos da Fonte 112.00.
//         </span>
//         </p>
//         <br/>`;

//         if (this.certificado.orcamentoCertificadoWrapper) {

//             if (this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.1. Análise Diferença na Dotação Inicial
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Confronto do saldo do campo ‘dotação inicial’ das despesas orçamentárias de todas as contas
//                     analíticas
//                     constantes no Balanço Orçamentário com a ‘dotação inicial’ da base de despesa da LOA.
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper.analisesModel) && (this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper.analisesModel.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências na Dotação Inicial, relacionadas no quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Conta
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição da Conta
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dotação Inicial Balanço </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dotação Inicial LOA
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper.analisesModel.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numConta} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dscConta}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.dotacaoBalanco)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.dotacaoSIOF)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         relativas à Dotação Inicial.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper.dsResultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.difDotacaoWrapper.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.2. Análise Consolidação de Despesas Orçamentárias
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Verificação da dotação atualizada, empenho, liquidação, pagamento e saldo da dotação, pela base da
//                     execução orçamentária e percentuais de execução em relação ao total.
// </span>
// </p>
// <br/>`;

//                 table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Função
//                         </span>
// </p>
// <br/>`;

//                 if ((this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFuncao) && (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFuncao.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências na Consolidação das Despesas Orçamentárias, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Função
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dotação Atualizada </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Liquidação
// </span></b>
// </p>
// </td>    
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Pagamento
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo da Dotação
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exec. Orçamentária
// </span></b>
// </p>
// </td>      
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFuncao.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.funcao} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.dotacaoAtualizada)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.empenho)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.liquidacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.pagamento)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoDotacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(this.calculaExecOrca(analise.empenho, analise.dotacaoAtualizada))}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                         divergências na Consolidação das Despesas Orçamentárias.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Programa
//                         </span>
// </p>
// <br/>`;

//                 if ((this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesPrograma) && (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesPrograma.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências na Consolidação das Despesas Orçamentárias, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Programa
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dotação Atualizada </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Liquidação
// </span></b>
// </p>
// </td>    
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Pagamento
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo da Dotação
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exec. Orçamentária
// </span></b>
// </p>
// </td>      
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesPrograma.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.programa} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.dotacaoAtualizada)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.empenho)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.liquidacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.pagamento)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.saldoDotacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(this.calculaExecOrca(analise.empenho, analise.dotacaoAtualizada))}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                         divergências na Consolidação das Despesas Orçamentárias.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 ■ Elemento de Despesa
//                                         </span>
//                 </p>
//                 <br/>`;

//                 if ((this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesElementos) && (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesElementos.length > 0)) {

//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                                         divergências na Consolidação das Despesas Orçamentárias, relacionadas no
//                                         quadro abaixo:
//                                         </span>
//                 </p>
//                 <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Elemento de Despesa
//                 </span></b>
//                 </p>
//                 </td>
                
//                 <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Dotação Atualizada </span> </b> </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Empenho
//                 </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Liquidação
//                 </span></b>
//                 </p>
//                 </td>    
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Pagamento
//                 </span></b>
//                 </p>
//                 </td> 
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Saldo da Dotação
//                 </span></b>
//                 </p>
//                 </td> 
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Exec. Orçamentária
//                 </span></b>
//                 </p>
//                 </td>      
//                 </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesElementos.forEach(analise => {
//                         table += `<tr>
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="100">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.tipoDespesaOrcamentaria} </span></span> </p>               
//                 </td>
             
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.dotacaoAtualizada)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.empenho)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.liquidacao)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.pagamento)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.saldoDotacao)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarPorcentagem(this.calculaExecOrca(analise.empenho, analise.dotacaoAtualizada))}
//                 </span></span> </p>
//                 </td>
                
//                 </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                                         divergências na Consolidação das Despesas Orçamentárias.
//                                                         </span>
//                                 </p>
//                                 <br/>`;
//                 }

//                 table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 ■ Fonte de Recurso
//                                         </span>
//                 </p>
//                 <br/>`;

//                 if ((this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFonte) && (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFonte.length > 0)) {

//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                                         divergências na Consolidação das Despesas Orçamentárias, relacionadas no
//                                         quadro abaixo:
//                                         </span>
//                 </p>
//                 <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Fonte
//                 </span></b>
//                 </p>
//                 </td>
               
//                 <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Dotação Atualizada </span> </b> </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Empenho
//                 </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Liquidação
//                 </span></b>
//                 </p>
//                 </td>    
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Pagamento
//                 </span></b>
//                 </p>
//                 </td> 
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Saldo da Dotação
//                 </span></b>
//                 </p>
//                 </td> 
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="100">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                 <b style="mso-bidi-font-weight:normal">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                 Exec. Orçamentária
//                 </span></b>
//                 </p>
//                 </td>      
//                 </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.analisesFonte.forEach(analise => {
//                         table += `<tr>
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="100">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.fonte} </span></span> </p>               
//                 </td>
            
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.dotacaoAtualizada)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.empenho)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.liquidacao)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.pagamento)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarValorNumerico(analise.saldoDotacao)}
//                 </span></span> </p>
//                 </td>
                
//                 <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="80">
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ this.formatarPorcentagem(this.calculaExecOrca(analise.empenho, analise.dotacaoAtualizada))}
//                 </span></span> </p>
//                 </td>
                
//                 </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                                         divergências na Consolidação das Despesas Orçamentárias.
//                                                         </span>
//                                 </p>
//                                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.dsResultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.consDespesasWrapper.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.orcamentoCertificadoWrapper.metasWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.3. Meta Prevista x Meta Realizada
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise da meta física prevista e a realizada dos programas de governo constantes no SIMA.
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.orcamentoCertificadoWrapper.metasWrapper.analises) && (this.certificado.orcamentoCertificadoWrapper.metasWrapper.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências entre as Metas Previstas e as Metas Realizadas, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Programa
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Meta Prevista
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Meta Realizada </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % de Execução
// </span></b>
// </p>
// </td>    
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.metasWrapper.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.programa} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.metaPrevista)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.metaRealizada)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.percExecucao)}
// </span></span> </p>
// </td>
// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre as Metas Previstas e Realizadas.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.metasWrapper.resultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.metasWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.4. Percentual da Execução Orçamentária x Meta Física
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise das iniciativas governamentais a partir da execução orçamentária e das metas físicas
//                     demonstradas no SIMA.
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper.analises) && (this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências entre o Percentual da Execução Orçamentária e as Metas Físicas, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Programa
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Programa Finalístico
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % Meta Física </span> </b> </p>
// </td>   
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.programa} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.percProgramaFinalistico)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.percMetasFisicas)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre o Percentual da Execução Orçamentária e as Metas Físicas.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper.resultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.execucaoXMetasWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.5. Análise das Despesas de Exercícios Anteriores
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// A verificação do saldo orçamentário deve está em consonância com o exercício de origem da despesa e
//                     com a categoria econômica própria. Sobreleva a dizer que o direito ao crédito do fornecedor de bens
//                     e serviços prescreve em 05 anos, ressalvada as exceções previstas em Lei.
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper.analises) && (this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências entre as Despesas de Exercícios Anteriores, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Exercício
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fonte de Recurso
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CGMA92 </span> </b> </p>
// </td>   
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Elemento de Despesa </span> </b> </p>
// </td> 
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valores </span> </b> </p>
// </td> 
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença </span> </b> </p>
// </td> 
// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.anoExercicio} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.fonteRecurso}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Cat. Econômica: </b>${ analise.categoriaEco}
//                                 <br />
//                                 <b>Grupo Desp.: </b>${ analise.grupoDespesa}
//                                 <br />
//                                 <b>Modalidade: </b>${ analise.modalidadeAplic}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.elementoDespesa}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Desp. Atual: </b>${ this.formatarValorNumerico(analise.somaDespesasExerc)}
//                                 <br />
//                                 <b>Saldo Anterior: </b>${ this.formatarValorNumerico(analise.saldoDotacaoAnterior)}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>
// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                 nas Despesas de Exercícios Anteriores.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper.resultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.exerciciosAnterioresWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">7.6. Aquisição de Bens x Fonte de Alienação de Ativos
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise das despesas realizadas com a fonte 112.00 (alienação de bens), empenhadas na categoria
//                     econômica 4 (despesa de capital).
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper.analises) && (this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise das peças processuais submetidas pelo jurisdicionado, foram identificadas
//                         divergências entre a Aquisição de Bens e as Fontes de Alienação de Ativos, relacionadas no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Elemento de Despesa
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor </span> </b> </p>
// </td>   

// </tr>`;

//                     this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numEmpenho} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.elementoDespesa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}                                
// </span></span> </p>
// </td>
// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre a Aquisição de Bencs e as Fontes de Alienação de Ativos.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper.resultadoAnalise) {
//                     table += `${this.certificado.orcamentoCertificadoWrapper.aquisicaoBensWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }

//     tabela_ocorrencias() {
//         let table = "";

//         if (this.certificado.listaOcorrenciaGeral) {


//             if ((this.certificado.listaOcorrenciaGeral) && (this.certificado.listaOcorrenciaGeral.length > 0)) {


//                 table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Módulo
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ocorrência
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Classificação </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Irregularidade
// </span></b>
// </p>
// </td>         
// </tr>`;

//                 this.certificado.listaOcorrenciaGeral.forEach(analise => {
//                     table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.tbModulo.dsModulo} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsOcorrencia}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.classificacao.dsClassificacao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${analise.irregularidade.noomeIrregularidade}
// </span></span> </p>
// </td>

// </tr>`;
//                 });
//                 table += `</tbody></table>`;
//             } else {
//                 table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas ocorrências.
//                                         </span>
//                 </p>
//                 <br/>`;
//             }
//         }

//         return table;
//     }
//     //#endregion

//     // ok
//     //#region Sprint 3
//     tabela_contratos() {
//         let table = `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//         style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.1. Relatório de Inspeção
//         </span></b> </p>`;


//         if (this.certificado.contratoCertificadoWrapper) {

//             if (this.certificado.contratoCertificadoWrapper.analiseRelatorioDeInspecao) {

//                 table += `
// <br />
// <p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//         style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//         </span></b> </p>
// <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseRelatorioDeInspecao.resumoAnalise) {
//                     table += this.certificado.contratoCertificadoWrapper.analiseRelatorioDeInspecao.resumoAnalise;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }

//                 table += `</span>
// </p>
// <br />
// `;
//             }

//             if (this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.2. Acréscimos ou Supressões de Contratos Versus Limite Legal
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da análise dos acréscimos e/ou supressões realizados nos contratos de obras, serviços e compras, verificou-se a não observância dos limites estipulados no art. 65, § 1º, da Lei 8.666/93. A tabela a           
//              seguir resume esses registros:</span>
// </p>
// <br/>`;

//                 if ((this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista.analises) && (this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista.analises.length > 0)) {

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//         <tr style="height:15.0pt">
//             <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="150">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Dados Contrato
//                         </span></b>
//                 </p>
//             </td>
//             <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="150">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Dados Aditivo(s)
//                         </span></b>
//                 </p>
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                 width="250">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Justificativa </span> </b> </p>
//             </td>           
//         </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista.analises.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="87">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Nº Contrato:</b> ${ analise.contrato.nmContrato} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Contratado:</b> ${ analise.contrato.credor}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Valor Original:</b> ${ this.formatarValorNumerico(analise.contrato.valorInicial)}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Valor Atualizado SACC:</b> ${ this.formatarValorNumerico(analise.contrato.valorAtual)}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Base de Cálculo:</b> ${ this.formatarValorNumerico(analise.valorAtualizadoCalculado)}</span></span> </p>
//                             </td>`;
//                         if (analise.contrato.aditivos && analise.contrato.aditivos.length > 0) {

//                             table += `<td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="150">
//                             <table>
//                                 <tr>
//                                     <td style="broder:0;">Nº</td>
//                                     <td style="broder:0;">Tipo</td>
//                                     <td style="broder:0;">Valor</td>
//                                     <td style="broder:0;">Acréscimos</td>
//                                     <td style="broder:0;">Supressões</td>
//                                 </tr>`;

//                             analise.contrato.aditivos.forEach(aditivo => {
//                                 table += `<tr>
//                                     <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ aditivo.nmAditivo}</span></span> </p></td>
//                                     <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ aditivo.tipoAditivo}</span></span> </p></td>
//                                     <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ this.formatarValorNumerico(aditivo.valor)}</span></span> </p></td>
//                                     <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ this.formatarValorNumerico(aditivo.totalAcrescimo)}</span></span> </p></td>
//                                     <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ this.formatarValorNumerico(aditivo.totalSupressao)}</span></span> </p></td>
//                                 </tr>`;
//                             });
//                             table += `</table></td>`;
//                         }
//                         table += `<td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="155">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.justificativa}
//                         </span></span> </p>
//                             </td>
//                             </tr>
// <tr>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt">
//                                 <tr>
//                                 <td>
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         <b>Total de acréscimos:</b> ${ this.somarValorDosAcrescimos(analise.contrato)}</span></span> </p></td>
//                                     <td>
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         <b>Total de supressões:</b> ${ this.somarValorDasSupressoes(analise.contrato)}</span></span> </p></td>
//                                 </tr>
//                                 <tr>
//                                     <td>
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         <b>Diferença acima do limite legal para acréscimos:</b> ${
//                             this.calcularDiferencaAcrescimos(analise.contrato)
//                             }</span></span> </p>
//                                     </td>
//                                     <td>
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                         <b>Diferença acima do limite legal para supressões:</b> ${
//                             this.calcularDiferencaSupressoes(analise.contrato)
//                             }</span></span> </p>
//                                     </td>
//                                 </tr>
//                             </td>
//                         </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">Com base nos dados e informações declaradas pelo jurisdicionado, não foram identificados
// contratos com acréscimos ou supressões
// em desacordo com os limites legais estabelecidos no § 1º do art. 65 da Lei nº 8.666/1995.</span>
// </p>
// <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//         <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseForaDoLimiteAnalista.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
// </p>`;
//             }

//             if (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.3. Extensão de Prazos Contratuais Acima dos Limites Regulamentados
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// A Lei nº 8.666/1993, em seu art. 57, incisos e parágrafos estabelece as regras para
//                         prorrogação dos contratos firmados com a Administração Pública.</span>
// </p>
// <br/>`;

//                 if ((this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises1) && (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises1.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Prazo de vigência acima de 60 meses até 72 meses</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base nos dados compulsados do SACC e do SCC, foram identificados os
//     contratos cuja vigência ultrapassou o prazo de 60 meses, sem que fosse apresentada
//     justificativa ou
//     cuja justificativa foi insuficiente para explicar a prorrogação acima do limite
//     previsto no art. 57, II,
//     da Lei nº 8.666/93. A tabela a seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Objeto </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor Original
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Datas
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência (meses)
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Situação dos Contratos/Convênios
//         </span></b>
// </p>
// </td>           
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises1.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.contrato.nmContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.objeto}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.contrato.valorInicial)}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nº Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Início Vigência:</b> ${ analise.contrato.inicioVigencia}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Fim Vigência:</b> ${ analise.contrato.novaDataVigencia}</span></span> </p>
//                                 <br />                                
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.meses}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.situacaoContratos}
//         </span></span> </p>
//             </td>
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 }

//                 if ((this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises2) && (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises2.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Prazo de vigência acima de 72 meses
//     </span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base nos dados do SACC e SCC, foram identificados os contratos cuja execução
//                                 ultrapassou o prazo máximo de 72 meses entre
//                                 sua data de início e término (60 meses, prorrogáveis por mais 12 - mediante
//                                 justificativa),
//                                 previsto no art. 57, II e § 4º, da Lei nº 8.666/93. A tabela a seguir resume esses
//                                 registros:
//                                 </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Objeto </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor Original
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Datas
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência (meses)
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Situação dos Contratos/Convênios
//         </span></b>
// </p>
// </td>           
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises2.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.contrato.nmContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.objeto}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.contrato.valorInicial)}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nº Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Início Vigência:</b> ${ analise.contrato.inicioVigencia}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Fim Vigência:</b> ${ analise.contrato.novaDataVigencia}</span></span> </p>
//                                 <br />                                
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.meses}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.situacaoContratos}
//         </span></span> </p>
//             </td>
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 }

//                 if ((this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises3) && (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises3.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Aluguel de Equipamentos e utilização de programas de informática
//     </span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base nas informações declaradas pelo jurisdicionado, bem como dos dados compulsados
//                                 dos
//                                 sistemas corporativos, foi identificada a ocorrência de prorrogação contratual em prazo
//                                 superior a
//                                 48 meses, portanto, em desconformidade com as disposições do inciso IV, do art. 57, da
//                                 Lei nº
//                                 8.666/1993, conforme demonstrado no quadro seguinte:
//                                 </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Objeto </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor Original
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Datas
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Prazo (meses)
//         </span></b>
// </p>
// </td>          
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises3.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.contrato.nmContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.objeto}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.contrato.valorInicial)}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nº Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Início Vigência:</b> ${ analise.contrato.inicioVigencia}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Fim Vigência:</b> ${ analise.contrato.novaDataVigencia}</span></span> </p>
//                                 <br />                                
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.meses}
//         </span></span> </p>
//             </td>
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 }

//                 if ((this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises4) && (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises4.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Hipóteses previstas nos incisos IX, XIX, XXVII e XXXI do art. 24 de Dispensa
//     </span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base nos dados do SACC e SCC, fundamentados nos incisos IX, XIX, XXVIII e XXXI do
//                                 art. 24, foram identificados os contratos
//                                 cuja execução ultrapassou o prazo máximo de 120 meses entre sua data de início e
//                                 término,
//                                 previsto no art. 57, V, da Lei Nº 8.666/93. A tabela a seguir resume esses registros:
//                                 </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Objeto </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor Original
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Datas
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência (meses)
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Situação dos Contratos/Convênios
//         </span></b>
// </p>
// </td>           
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises4.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.contrato.nmContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.objeto}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.contrato.valorInicial)}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nº Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Início Vigência:</b> ${ analise.contrato.inicioVigencia}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Fim Vigência:</b> ${ analise.contrato.novaDataVigencia}</span></span> </p>
//                                 <br />                                
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.meses}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.situacaoContratos}
//         </span></span> </p>
//             </td>
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 }

//                 if ((this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises5) && (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises5.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Aditamentos Realizados Fora da Vigência Contratual
//     </span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Consoante dispõe o inciso II, do art. 57, da Lei nº 8.666/1993, os serviços de duração
//                                 continuada poderão ser prorrogados
//                                 por iguais e sucessivos períodos. Com base nos dados e informações declaradas pelo
//                                 jurisdicionado,
//                                 foi identificada a ocorrência de prorrogação de contrato em desconformidade com a lei,
//                                 conforme
//                                 demonstrado no quadro seguinte:
//                                 </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Objeto </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Aditivos
//         </span></b>
// </p>
// </td>       
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.analises5.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.contrato.nmContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="180">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.contrato.objeto}
//         </span></span> </p>
//             </td>`;


//                         if (analise.contrato.aditivos && analise.contrato.aditivos.length > 0) {

//                             table += `<td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                 width="180">
//                 <table>
//                     <tr>
//                         <td style="broder:0;">Nº</td>
//                         <td style="broder:0;">Tipo</td>
//                         <td style="broder:0;">Datas</td>                        
//                     </tr>`;

//                             analise.contrato.aditivos.forEach(aditivo => {
//                                 table += `<tr>
//                         <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ aditivo.nmAditivo}</span></span> </p></td>
//                         <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">${ aditivo.tipoAditivo}</span></span> </p></td>
//                         <td style="broder:0;"><p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         <b>Assinatura: </b> ${ aditivo.assinatura}
//                                         <br />
//                                         <b>Vigência Final: </b> ${aditivo.novaDataVigencia}
//                                         <br />
//                                         <b>Prazo (dias): </b> ${ aditivo.diasDiferencaSequencia}</span></span> </p></td>
//                     </tr>`;
//                             });
//                             table += `</table></td>`;
//                         }


//                         table += `       
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 }


//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
// style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
// </span></b> </p>
// <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseExtensaoAcimaLimite.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
// </p>`;
//             }

//             if (this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.4. Registro de despesas sem contrato, em desacordo com o Art.62 da Lei Federal nº 8.666/93
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// A Lei nº 8.666/1993, no § Único do art. 60 c/c o Art. 62, veda a realização de
// despesas mediante contratos verbais ou sem contrato, com as ressalvas previstas nos próprios
// artigos.
// </span>
// </p>
// <br/>`;


//                 if ((this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.analises) && (this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Segundo disciplina o caput do art. 62, as aquisições decorrentes de concorrência e tomada de
//                         preços, bem como das dispensas
//                         e inexigibilidades com preços dentro dos limites dessas duas modalidades, devem ser
//                         acompanhadas
//                         do devido instrumento contratual. Com base nos dados e informações declaradas pelo
//                         jurisdicionado,
//                         identificou-se a ocorrência de aquisições em desacordo com a norma legal, conforme relacionado
//                         no
//                         quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nota Empenho
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ordenador </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Item Nat. Despesa
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Executado
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.notaEmpenho}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.ordenador}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dscItemNaturezaDespesa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.meses}
// </span></span> </p>
// </td>
// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 De acordo com as análises realizadas, não foram constatadas a execução de
//                         despesas em desacordo com as disposições da Lei Federal Nº 8.666/93.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Desta forma, solicita-se, para análise, o envio do(s) contrato(s) relativo(s) aos empenhos
//                 acima listados e nas hipóteses
//                 de faculdade do instrumento de contrato, prevista no art. 62 da Lei nº 8.666/93, enviar os
//                 outros
//                 instrumentos hábeis, tais como carta-contrato, nota de empenho de despesa, autorização de
//                 compra
//                 ou ordem de execução de serviço.
//                                         </span>
//                 </p>
//                 <br/>`;

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratoCertificadoWrapper.analiseValidacaoDataPublicacao) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.5. Publicação Fora do Prazo Legal, em Desacordo com a Lei 8.666/93, Art. 61, Parágrafo Único
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// O parágrafo único do art. 61 da Lei nº 8.666/1993 dispõe que a minuta resumida do
//                     instrumento contratual é condição indispensável para eficácia do ajuste, devendo ser providenciada
//                     até o 5º dia útil do mês seguinte ao da assinatura, para ocorrer no prazo de vinte dias daquela
//                     data,
//                     independente do valor ou mesmo sem ônus.
//                     </span>
// </p>
// <br/>`;


//                 if ((this.certificado.contratoCertificadoWrapper.analiseValidacaoDataPublicacao.analises) && (this.certificado.contratoCertificadoWrapper.analiseValidacaoDataPublicacao.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Contratos
// </p>
// <br/>`;

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base nos dados e informações declaradas pelo jurisdicionado, bem das
//                         informações compulsadas dos sistemas corporativos, identificou-se a publicação de extratos
//                         contratuais e de aditivos em desacordo com a norma legal, conforme relacionado nos quadros
//                         abaixo:
// </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Prazo para Publicação
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fora do Prazo (dias)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Situação
// </span></b>
// </p>
// </td>     
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseValidacaoDataDePublicacao.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.credor}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nº Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                 <br />
//                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 <b>Publicação:</b> ${ analise.contrato.dataPublicacao}</span></span> </p>
//                 <br />                
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.dtPrazoPublicacao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//  ${ analise.contrato.diasForaDoPrazo}         
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.situacao}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base no Diário Oficial do Estado (DOE), constatou-se que não foram identificados Contratos
//                         que apresentaram, entre sua
//                         data de assinatura e data de publicação, um prazo superior ao quinto dia útil após a
//                         assinatura,
//                         acrescido de 20 dias, em desacordo com o prazo legal disposto no Art. 61, parágrafo único da
//                         Lei
//                         8.666/93.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }


//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
// style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
// </span></b> </p>
// <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseValidacaoDataPublicacao.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseValidacaoDataPublicacao.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
// </p>`;





//                 if ((this.certificado.contratoCertificadoWrapper.analiseValidacaoAditivoDataWrapper.analises) && (this.certificado.contratoCertificadoWrapper.analiseValidacaoAditivoDataWrapper.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// ■ Aditivos
// </p>
// <br/>`;

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base no Diário Oficial do Estado (DOE), foram identificados Aditivos que apresentaram,
//                         entre sua data de assinatura e
//                         data de publicação, um prazo superior ao quinto dia útil após a assinatura, acrescido de 20
//                         dias,
//                         contrariando o prazo legal disposto no Art. 61, parágrafo único da Lei 8.666/93. A tabela a
//                         seguir
//                         resume esses registros:
// </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Aditivo
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Prazo para Publicação
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fora do Prazo (dias)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Situação
// </span></b>
// </p>
// </td>     
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseValidacaoAditivoDataWrapper.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.credor}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.aditivo.nmAditivo} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nº Assinatura:</b> ${ analise.aditivo.assinatura} </span></span> </p>
// <br />
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Publicação:</b> ${ analise.aditivo.dataPublicacao}</span></span> </p>
// <br />                
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.aditivo.dtPrazoPublicacao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.aditivo.diasAtraso}         
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.aditivo.situacao}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base nos dados e informações declaradas pelo jurisdicionado, bem das
//                         consultas realizadas no Diário Oficial do Estado (DOE), não foram identificadas publicações de
//                         extratos contratuais ou de aditivos em desacordo com a norma legal.
//                         </span>
// </p>
// <br/>`;
//                 }


//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
// style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
// </span></b> </p>
// <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseValidacaoAditivoDataWrapper.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseValidacaoAditivoDataWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
// </p>`;


//             }

//             if (this.certificado.contratoCertificadoWrapper.analiseEmpenhoPosterior) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">8.6. Empenho Posterior à Vigência do Contrato
//                 </span></b> </p>

// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Compulsando os dados do SIAFE, constatou-se a ocorrência da realização de empenhos com data
//                         posterior a vigência do contrato, conforme relação constante do quadro abaixo:</span>
// </p>
// <br/>`;






//                 if ((this.certificado.contratoCertificadoWrapper.analiseEmpenhoPosterior.analises) && (this.certificado.contratoCertificadoWrapper.analiseEmpenhoPosterior.analises.length > 0)) {


//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Empenho
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ordenador da Despesa </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Empenhado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td>     
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtd. de Dias da Emissão
// </span></b>
// </p>
// </td>      
// </tr>`;

//                     this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contrato.credor}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.empenho}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.ordenador}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorEmpenhado)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Assinatura:</b> ${ analise.contrato.dataAssinatura} </span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Vigência Final:</b> ${ analise.contrato.novaDataVigencia}</span></span> </p>
//                                 <br />
//                                 <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 <b>Empenho:</b> ${ analise.dataEmpenho}</span></span> </p>
//                                 <br />
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.qtdDias}
// </span></span> </p>
// </td>
// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// De acordo com as análises realizadas, não foram constatadas a execução de
//         despesas em desacordo com as disposições da Lei Federal Nº 8.666/93.
//                         </span>
// </p>
// <br/>`;
//                 }

//                 table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Desta forma, solicita-se, para análise, o envio do(s) contrato(s) relativo(s) aos empenhos
// acima listados e nas hipóteses
// de faculdade do instrumento de contrato, prevista no art. 62 da Lei nº 8.666/93, enviar os
// outros
// instrumentos hábeis, tais como carta-contrato, nota de empenho de despesa, autorização de
// compra
// ou ordem de execução de serviço.
//                         </span>
// </p>
// <br/>`;

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
// style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
// </span></b> </p>
// <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.resultadoAnalise) {
//                     table += `${this.certificado.contratoCertificadoWrapper.analiseNotasSemContrato.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
// </p>`;




//             }

//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             A partir do exame da documentação encaminhada pelo jurisdicionado e da compilação de dados extraídos
//             dos sistemas corporativos
//             do Estado e de apoio à gestão, não foram verificadas ocorrências merecedoras de esclarecimento no que
//             tange
//             aos contratos e aditivos realizados ou vigentes no exercício.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }

//     tabela_licitacoes() {
//         let table = `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//         style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.1. Relatório de Inspeção
//         </span></b> </p>`;

//         if (this.certificado.licitacaoCertificado) {

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra1) {
//                 table += `
//                 <br />
//                 <p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                         style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                         </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra1.dsResultadoAnalise) {
//                     table += this.certificado.licitacaoCertificado.analiseLicitacaoRegra1.dsResultadoAnalise;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }

//                 table += `</span>
//                 </p>
//                 <br />
//                 `;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra2) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.2. Visão Gerencial das Licitações Realizadas
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra2.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra2.analises.modalidades > 0)) {

//                     table += `<div #chart></div>`;

//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra2.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra2.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra3) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.3. Bens e Serviços Comuns que Não se Enquadram no Conceito de Comuns - Modalidade Pregrão
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra3.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra3.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que
//             existem aquisições
//             de bens e serviços que não se enquadram no conceito de comuns, onde a modalidade de licitação é Pregão, em
//             dissonância
//             com os ditames estabelecidos pela Lei 10.520/2002.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vigência
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Objeto
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Contrato </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra3.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numeroContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início:</b> ${ analise.dataInicio}
//                 <br />
//                 <b>Fim:</b> ${ analise.dataFim}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.objeto}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nota:</b> ${ analise.notaEmpenho}
//                 <br />
//                 <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                 <br />
//                 <b>Elem. Despesa:</b> ${ analise.elementoDespesa}
//                  </span></span> </p>  
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem aquisições
//             de bens e serviços comuns que não se enquadram no conceito de comuns, onde a modalidade de licitação é
//             Pregão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra3.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra3.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra4) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.4. Aquisição de Bens e Serviços Comuns por Meio de Convite, Tomada de Preços ou Concorrência
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra4.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra4.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Conforme estabelece o Inciso I do Decreto nº 29.337 de 27 de junho de 2008, no âmbito dos órgãos e
//             entidades da Administração
//             Pública Estadual, nas aquisições de bens e serviços de engenharia, bem como de outros bens e serviços,
//             aplicam-se
//             os limites estabelecidos nos incisos I e II do Art. 23 da Lei nº 8.666/1993, com redação dada pelo Lei
//             Federal
//             nº 9.648/1998. A tabela a seguir resume esses registros:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Modalidade
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vigência
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Contrato </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra4.analises.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.modalidade}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numeroContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início:</b> ${ analise.dataInicio}
//                 <br />
//                 <b>Fim:</b> ${ analise.dataFim}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nota:</b> ${ analise.notaEmpenho}
//                 <br />
//                 <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                 <br />
//                 <b>Elem. Despesa:</b> ${ analise.elementoDespesa}
//                  </span></span> </p>  
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem aquisições
//             de bens e serviços Comuns por Meio de Convite, Tomada de Preços ou Concorrência.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra4.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra4.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.5. Modalidade de Licitação versus Valor Contratado
//                 </span></b> </p>`;

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises1) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises1.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Modalidade: Convite</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas contratações por
//             meio de Licitação
//             na modalidade Convite, onde o limite de contratação ultrapassa os valores de R$ 150.000,00, para Obras e
//             Serviços
//             de Engenharia, ou R$ 80.000,00, para Compras e Serviços, de encontro ao estabelecido no art. 23, inciso I,
//             a,
//             e inciso II, a, da Lei nº 8.666/93. A tabela a seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises1.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>           
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existe contratação
//             por meio de Licitação na modalidade Convite, onde o limite de contratação ultrapassa os valores de R$
//             150.000,00,
//             para Obras e Serviços de Engenharia, ou R$ 80.000,00, para Compras e Serviços, de encontro ao estabelecido
//             no
//             art. 23, inciso I, a, e inciso II, a, da Lei nº 8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises2) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises2.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Modalidade: Tomada de Preço</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas contratações por
//             meio de Licitação
//             na modalidade Tomada de Preço, onde o limite de contratação ultrapassa os valores de R$ 1.500.000,00, para
//             Obras
//             e Serviços de Engenharia, ou R$ 650.000,00, para Compras e Serviços, de encontro ao estabelecido no art.
//             23,
//             inciso I, b, e inciso II, b, da Lei nº 8.666/93. A tabela a seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises2.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>           
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existe contratação
//             por meio de Licitação na modalidade Tomada de Preço, onde o limite de contratação ultrapassa os valores de
//             R$
//             1.500.000,00, para Obras e Serviços de Engenharia, ou R$ 650.000,00, para Compras e Serviços, de encontro
//             ao
//             estabelecido no art. 23, inciso I, b, e inciso II, b, da Lei nº 8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises3) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises3.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Modalidade: Concorrência</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas contratações por
//             meio de Licitação
//             na modalidade Concorrência, onde a contratação é inferior aos valores R$ 1.500.000,00, para Obras e
//             Serviços
//             de Engenharia, ou R$ 650.000,00, para Compras e Serviços, divergente dos limites estabelecidos no art. 23
//             da
//             Lei nº 8.666/93. A tabela a seguir resume esses registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.analises3.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>           
//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//                     existe contratação
//                     por meio de Licitação na modalidade Concorrência, onde a contratação é inferior aos valores R$
//                     1.500.000,00,
//                     para Obras e Serviços de Engenharia, ou R$ 650.000,00, para Compras e Serviços, divergente dos limites
//                     estabelecidos
//                     no art. 23 da Lei nº 8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }


//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.resumoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.resumoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra6) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.6. Contratação de Obras e Serviços de Engenharia Acima do Limite de Dispensa de Licitação
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra6.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra6.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Conforme estabelece o Inciso II do Decreto nº 29.337 de 27 de junho de 2008, no âmbito dos órgãos e
//             entidades da Administração
//             Pública Estadual, nas aquisições de bens e serviços de engenharia, bem como de outros bens e serviços,
//             aplicam-se
//             os limites estabelecidos nos incisos I e II do Art. 24 da Lei nº 8.666/1993, com redação dada pelo Lei
//             Federal
//             nº 9.648/1998. A tabela a seguir resume esses registros:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vigência
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Contrato </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra6.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numeroContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início:</b> ${ analise.dataInicio}
//                 <br />
//                 <b>Fim:</b> ${ analise.dataFim}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nota:</b> ${ analise.notaEmpenho}
//                 <br />
//                 <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                 <br />
//                 <b>Elem. Despesa:</b> ${ analise.elementoDespesa}
//                 <br />
//                 <b>Ordenador: </b> ${ analise.ordenador}
//                  </span></span> </p>  
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Contratações
//             de Obras e Serviços de Engenharia que ultrapassam o limite de dispensa de licitação.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra6.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra6.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra7) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.7. Aquisição de Outros Serviços e Compras Acima do Limite de Dispensa de Licitação
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra7.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra7.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas aquisições de
//             Outros Serviços e Compras
//             que ultrapassam o limite de dispensa de licitação, previsto no art. 24, inciso II, da lei nº 8.666/93. A
//             tabela
//             a seguir resume esses registros:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contratado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vigência
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Contrato </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Empenho
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra7.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.numeroContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início:</b> ${ analise.dataInicio}
//                 <br />
//                 <b>Fim:</b> ${ analise.dataFim}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nota:</b> ${ analise.notaEmpenho}
//                 <br />
//                 <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                 <br />
//                 <b>Elem. Despesa:</b> ${ analise.elementoDespesa}
//                 <br />
//                 <b>Ordenador: </b> ${ analise.ordenador}
//                  </span></span> </p>  
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Aquisições
//             de Outros Serviços e Compras que ultrapassam o limite de dispensa de licitação.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra7.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra7.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.8. Dispensa de Licitação Incompatível com os dispositivos do Art.24, Incisos III a XXIX da Lei Federal nº
//                 8.666/93                
//                 </span></b> </p>`;

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesI) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesI.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Incisos III, IV, V, VI, VII, VIII, IX, X, XI, XII, XIII, XIV, XV, XVII, XVIII, XIX,
//     XX, XXI, XXV, XXVI, XXVII,
//     XXVIII, XXIX, XXX, XXXI, XXXII, XXXIII e XXXIV</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Dispensas de
//             Licitação Incompatíveis
//             com os dispositivos do Art.24, Incisos III, IV, V, VI, VII, VIII, IX, X, XI, XII, XIII, XIV, XV, XVII,
//             XVIII,
//             XIX, XX, XXI, XXV, XXVI, XXVII, XXVIII, XXIX, XXX, XXXI, XXXII, XXXIII e XXXIV da Lei Federal nº 8.666/93.
//             A
//             tabela a seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Inciso
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Empenho
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesI.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.inciso} </span></span> </p>               
//             </td>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>    
            
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td>   
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Dispensas
//             de Licitação Incompatíveis com os dispositivos do Art.24, Incisos III, IV, V, VI, VII, VIII, IX, X, XI,
//             XII,
//             XIII, XIV, XV, XVII, XVIII, XIX, XX, XXI, XXV, XXVI, XXVII, XXVIII, XXIX, XXX, XXXI, XXXII, XXXIII e XXXIV
//             da
//             Lei Federal nº 8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesII) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesII.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Inciso XVI - Impressão dos Diários Oficiais, de Formulários Padronizados e
//     Prestação de Serviços de Informática
//     por Órgãos ou Entidades que Integrem a Adm. Pública</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Dispensas de
//             Licitação incompatíveis
//             com os dispositivos do Art.24, inciso XVI, da Lei Federal nº 8.666/93. A tabela a seguir resume esses
//             registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Empenho
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesII.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>   
            
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td>   
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Dispensas
//             de Licitação Incompatíveis com os dispositivos do Art.24, Inciso XVI, da Lei Federal nº 8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIII) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIII.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Inciso XXII - Concessionárias de energia elétrica e gás natural</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Dispensas de
//             Licitação Incompatíveis
//             com os dispositivos do Art.24, Inciso XXII, da Lei Federal nº 8.666/93. A tabela a seguir resume esses
//             registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>

//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Empenho
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIII.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>   
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td> 

//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Dispensas
//             de Licitação Incompatíveis com os dispositivos do Art.24, Inciso XXII, da Lei Federal nº 8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIV) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIV.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Inciso XXIII - Empresa Pública ou Sociedade Economia Mista</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Dispensas de
//             Licitação Incompatíveis
//             com os dispositivos do Art.24, Inciso XXIII, da Lei Federal nº 8.666/93. A tabela a seguir resume esses
//             registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>

//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Empenho
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesIV.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>   
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td> 

//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             existem Dispensas
//             de Licitação Incompatíveis com os dispositivos do Art.24, Inciso XXIII, da Lei Federal nº 8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesV) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesV.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Inciso XXIV - Organizações Sociais</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Dispensas de
//             Licitação Incompatíveis
//             com os dispositivos do Art.24, Inciso XXIV, da Lei Federal nº 8.666/93. A tabela a seguir resume esses
//             registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>

//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Empenho
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.analisesV.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>   
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td> 

//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//                     existem Dispensas
//                     de Licitação Incompatíveis com os dispositivos do Art.24, Inciso XXIV, da Lei Federal nº 8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra8.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra9) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.9. Inexigibilidade de Licitação Incompatível com os Dispositivos do Art.25, Incisos I ao III da Lei Federal
//                 nº 8.666/93
//                 </span></b> </p>`;

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesI) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesI.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Inciso I</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas despesas,
//               classificadas como Inexigibilidades
//               de Licitação, incompatíveis com os dispositivos do Art.25, inciso I, da Lei Federal nº 8.666/93. A tabela
//               a
//               seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Nº Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Empenho
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesI.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>    
            
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td>   
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que
//               não foram identificado
//               Inexigibilidade de Licitação Incompatível com os Dispositivos do Art.25, Inciso I da Lei Federal nº
//               8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesII) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesII.length > 0)) {

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     ■ Inciso II</span>
//     </p>
//     <br/>`;

//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas despesas,
//               classificadas como Inexigibilidades
//               de Licitação, incompatíveis com os dispositivos do Art.25, Inciso II, da Lei Federal nº 8.666/93. A
//               tabela
//               a seguir resume esses registros:
//     </span>
//     </p>
//     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contrato
//         </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Contratado
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Vigência
//         </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Valor do Contrato
//         </span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//     <b style="mso-bidi-font-weight:normal">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//             Empenho
//         </span></b>
// </p>
// </td>

// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesII.forEach(analise => {
//                         table += `<tr>
//         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                 ${ analise.numeroContrato} </span></span> </p>               
//             </td>
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ analise.credor}
//         </span></span> </p>
//             </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//             width="120">
//             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                     <br />
//                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                     <br />                                    
//             </span></span> </p>
//                 </td>

//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="80">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         ${ this.formatarValorNumerico(analise.valor)}
//         </span></span> </p>
//             </td>   
            
//             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td>   
//             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que
//               não foram identificado
//               Inexigibilidade de Licitação Incompatível com os Dispositivos do Art.25, Inciso II da Lei Federal nº
//               8.666/93.
//     </span>
//     </p>
//     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIII) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIII.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Inciso III</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas despesas,
//               classificadas como Inexigibilidades
//               de Licitação, incompatíveis com os dispositivos do Art.25, Inciso III, da Lei Federal nº 8.666/93. A
//               tabela
//               a seguir resume esses registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>

//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Empenho
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIII.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>   
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td> 

//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que
//               não foram identificado
//               Inexigibilidade de Licitação Incompatível com os Dispositivos do Art.25, Inciso III da Lei Federal nº
//               8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }

//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIV) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIV.length > 0)) {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     ■ Caput do art. 25 da Lei 8.666/93 (quando houver inviabilidade de competição)</span>
//                     </p>
//                     <br/>`;

//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificadas Inexigibilidades
//               de Licitação Incompatíveis
//               com o Caput do Art.25 da Lei Federal nº 8.666/93. A tabela a seguir resume esses registros:
//                     </span>
//                     </p>
//                     <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                 <tr style="height:15.0pt">
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contrato
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Contratado
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Vigência
//                         </span></b>
//                 </p>
//                 </td>
//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="80">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Valor do Contrato
//                         </span></b>
//                 </p>
//                 </td>

//                 <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="120">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Empenho
//                         </span></b>
//                 </p>
//                 </td>
                
//                 </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra9.analisesIV.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                 ${ analise.numeroContrato} </span></span> </p>               
//                             </td>
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="120">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ analise.credor}
//                         </span></span> </p>
//                             </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                             width="120">
//                             <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                             <b>Nº Início:</b> ${ analise.dataInicio} </span></span> </p>
//                                                     <br />
//                                                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                                                     <b>Fim:</b> ${ analise.dataFim}</span></span> </p>
//                                                     <br />                                    
//                             </span></span> </p>
//                                 </td>
                
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                         width="80">
//                         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                         ${ this.formatarValorNumerico(analise.valor)}
//                         </span></span> </p>
//                             </td>   
                            
//                             <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//         width="120">
//         <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//         <b>Nota:</b> ${ analise.notaEmpenho}
//                   <br />
//                   <b>Valor:</b> ${ this.formatarValorNumerico(analise.valorEmpenhado)}
//                   <br />
//                   <b> Item Despesa: </b> ${ analise.elementoDespesa}
//                   <br />
//                   <b>Ordenador: </b> ${ analise.ordenador}
//         </span></span> </p>
//             </td> 

//                             </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                     Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que
//               não foram identificado
//               Inexigibilidade de Licitação Incompatível com o Caput do Art.25 da Lei Federal nº 8.666/93.
//                     </span>
//                     </p>
//                     <br/>`;
//                 }


//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra5.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra10) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">9.10. Analisar Potenciais Direcionamento de Fornecedores
//                 </span></b> </p>`;


//                 if ((this.certificado.licitacaoCertificado.analiseLicitacaoRegra10.analises) && (this.certificado.licitacaoCertificado.analiseLicitacaoRegra10.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base no Sistema de Gestão Governamental por Resultados (SIAFE), foram identificados indícios de
//             Direcionamento a Fornecedores.
//             A tabela a seguir resume esses registros:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fornecedor
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Modalidade
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. de Contratos
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Total </span> </b> </p>
// </td>      
// </tr>`;

//                     this.certificado.licitacaoCertificado.analiseLicitacaoRegra10.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.fornecedor} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.modalidade}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.qtdContratos}                
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valor)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Conforme pesquisa realizada no Sistema de Gestão Governamental por Resultados - SIAFE, constatou-se que não
//             há indícios de
//             direcionamento de fornecedores.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.licitacaoCertificado.analiseLicitacaoRegra10.resultadoAnalise) {
//                     table += `${this.certificado.licitacaoCertificado.analiseLicitacaoRegra10.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }


//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há licitações incluídas no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }
//         return table;
//     }
//     //#endregion

//     //#region Sprint 4
//     tabela_tce() {
//         let table = "";

//         if (this.certificado.tomadaCECertificado) {

//             if (this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">11.1. Tomada de Contas Especial não instaurada (Art. 6º da IN TCE nº 3/2017)
//                 </span></b> </p>`;


//                 if ((this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.analiseTCEPrestacaoPendente) && (this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.analiseTCEPrestacaoPendente.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Na análise das Tomadas de Contas Especiais, foram identificadas Convênios ou Congêneres,
//                         listados no quadro abaixo, sem a devida instauração imediata de Tomadas de Contas Especial,
//                         segundo o art. 6º da IN TCE nº 3/2017.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº SACC/SICC/eParcerias
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome do Convenente
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fator Gerador </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Status do COnvênio (eParcerias)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.analiseTCEPrestacaoPendente.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmSaccInstrumento} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsConvenente}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmFatorGeradorInadiplencia}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.statusConvenio}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Celebração: </b> ${ analise.dtCelebracao}
// <br />
// <b>Limite: </b>${ analise.dtDataLimite}
// <br />
// <b>Dias Atrasados: </b> ${ analise.nmDiasAtrasados}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado e consulta no eParcerias, não foram
//                         identificados Convênios ou Congêneres pendentes de Prestação de Contas.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.dsResumoAnalise) {
//                     table += `${this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.dsResumoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.tomadaCECertificado.analiseTCEForaDoPrazo) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">11.2. Tomada de Contas Especial Encaminhadas Fora do Prazo Legal (Art.14 da IN TCE nº 3/2017)
//                 </span></b> </p>`;


//                 if ((this.certificado.tomadaCECertificado.analiseTCEForaDoPrazo.analiseTCEForaDoPrazo) && (this.certificado.tomadaCECertificado.analiseTCEForaDoPrazo.analiseTCEForaDoPrazo.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Na análise das Tomadas de Contas Especiais, foram identificados Convênios ou Congêneres,
//                         listados no quadro abaixo, com Tomadas de Contas Especial encaminhadas fora do prazo legal,
//                         segundo o art. 14 da IN TCE nº 3/2017.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº SACC
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Convênio
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome do Convenente
// </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qualificação do Dano
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fator Gerador
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Protocolo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td>
// </tr>`;

//                     this.certificado.tomadaCECertificado.analiseTCEPrestacaoPendente.analiseTCEPrestacaoPendente.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmSacc} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmConvenio}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsConvenente}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorConvenio)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsDano}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmFatorGerador}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmProtocoloGeral}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Publicação: </b> ${ analise.dtPublicacao}
// <br />
// <b>Protocolo: </b>${ analise.dtProtocolo}
// <br />
// <b>Dias Atrasados: </b> ${ analise.nmDiasAtrasados}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado e consulta no eParcerias, não foram
//                         identificados Convênios ou Congêneres que enviaram tomada de contas fora do prazo legal.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.tomadaCECertificado.analiseTCEForaDoPrazo.dsResumoAnalise) {
//                     table += `${this.certificado.tomadaCECertificado.analiseTCEForaDoPrazo.dsResumoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.tomadaCECertificado.analiseTCENaoEnviado) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">11.3. Tomada de Contas Especial Não Enviadas para o Tribunal de Contas do Estado (Art.14 da IN TCE nº
//                     3/2017)
//                 </span></b> </p>`;


//                 if ((this.certificado.tomadaCECertificado.analiseTCENaoEnviado.analiseTCENaoEnviado) && (this.certificado.tomadaCECertificado.analiseTCENaoEnviado.analiseTCENaoEnviado.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Na análise das Tomadas de Contas Especiais, foram identificadas Convênios ou Congêneres,
//                         listados no quadro abaixo, sem as devidas Tomadas de Contas enviadas para o Tribunal de Contas
//                         do Estado, segundo o art. 14 da IN TCE nº 3/2017.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº SACC
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome do Convenente
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Convênio </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dano
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Fator Gerador
// </span></b>
// </p>
// </td>  

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Justificativa
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.tomadaCECertificado.analiseTCENaoEnviado.analiseTCENaoEnviado.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmSacc} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsConvenente}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorConvenio)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.nmDano)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.fatorGerador === 0) {
//                             table += `Ausência de Prestação de Contas`;
//                         } else if (analise.fatorGerador === 1) {
//                             table += `Prestação de Contas Reprovadas`;
//                         } else if (analise.fatorGerador === 2) {
//                             table += `Demais Casos`;
//                         } else if (analise.fatorGerador === 3) {
//                             table += `Ausência de Análise de Prestação de Contas`;
//                         }

//                         table += `</span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dsJustificativa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Fim Vigência: </b> ${ analise.dtFimVigencia}
//                                 <br />
//                                 <b>Limite: </b>${ analise.dtLimite}
//                                 <br />
//                                 <b>Dias Atrasados: </b>${ this.calcularDiferencaData(analise)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado e consulta no eParcerias, não foram
//                         identificados Convênios ou Congêneres, listados no quadro abaixo, que não enviaram Tomada de
//                         Contas especial
//                         para o Tribunal de Contas do Estado, segundo o art. 14 da IN TCE n&deg;3/2017.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.tomadaCECertificado.analiseTCENaoEnviado.dsResumoAnalise) {
//                     table += `${this.certificado.tomadaCECertificado.analiseTCENaoEnviado.dsResumoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }

//     tabela_convenios() {
//         let table = "";

//         if (this.certificado.conveniosCertificado && this.certificado.conveniosCertificado > 0) {
//             table = ``;
//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }
//     //#endregion

//     // ok
//     //#region Sprint 5
//     tabela_cg() {
//         let table = "";

//         if (this.certificado.contratosGestaoCertificado) {
//             if (this.certificado.contratosGestaoCertificado.listaVerificacaoRol) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.1. Verificação do Rol de Responsáveis
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaVerificacaoRol) && (this.certificado.contratosGestaoCertificado.listaVerificacaoRol.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base nas informações reportadas pelo jurisdicionado, foram identificadas divergências no Rol de
//             Responsáveis,
//             a seguir detalhadas.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Grupo/Subgrupo
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CPF </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// SubGrupo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Tipo de Responsável
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaVerificacaoRol.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.pessoaGrupo.nmGrupo} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.pessoaGrupo.pessoa.nomePessoa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.cpf_mask(analise.pessoaGrupo.pessoa.cpf)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.pessoaGrupo.subGrupo.dsSubgrupo}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.tipoResponsavel.dsTipo}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências com o Rol de
//             Responsáveis.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseVerificacaoRol) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseVerificacaoRol}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaRelatorioFisico) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.2. Análise do Relatório Físico-Financeiro
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaRelatorioFisico) && (this.certificado.contratosGestaoCertificado.listaRelatorioFisico.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Conforme dispõe a Lei nº 12.781, de 30.12.97, atualizada pelas Leis nº 13.484/2004 e 14.158/2008, em seu
// art. 10, § 1º,
// o contrato de gestão deve permitir ao Poder Público requerer a apresentação pela entidade qualificada de
// relatório pertinente à execução do contrato de gestão,
// contendo comparativo específico das metas propostas com os resultados alcançados.</p>

// <p>De acordo com as informações reportadas pelo Jurisdicionado, verificou-se impropriedades, listadas
// abaixo,
// do resultado da análise realizada no Relatório Físico-Financeiro de Execução do Contrato de Gestão.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato SACC/SCC
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Meta
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Atividade </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Previsto
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Realizado
// </span></b>
// </p>
// </td>   

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % de Execução
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Variação Valor Un.
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaRelatorioFisico.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorio.contratoGestao.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorio.dsMetas}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorio.dsAtividade}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Qtde.: </b> ${ this.formatarValorNumerico(analise.relatorio.quantidadePrevista)}
//                 <br />
//                 <b>Valor Un.: </b>${ this.formatarValorNumerico(analise.relatorio.valorUnitarioPrevisto)}
//                 <br />
//                 <b>Total: </b>${ this.formatarValorNumerico(analise.relatorio.totalPrevisto)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Qtde.: </b>${ this.formatarValorNumerico(analise.relatorio.quantidadeRealizada)}
//                 <br />
//                 <b>Valor Un.: </b>${ this.formatarValorNumerico(analise.relatorio.valorUnitarioRealizado)}
//                 <br />
//                 <b>Total: </b>${ this.formatarValorNumerico(analise.relatorio.totalRealizado)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.percentualExecucao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.percentualQuantidade < 0) {
//                             table += `<b>Qtde.: </b>
//  <br />
//  ${ this.formatarPorcentagem(analise.percentualQuantidade)}
//  <span style="font-family:&quot;Arial&quot;,sans-serif;color:red;">
//    <i class="fa fa-arrow-down" aria-hidden="true"></i>
//  </span>`;
//                         } else {
//                             table += `<b>Qtde.: </b>
//     <br />
//     ${ this.formatarPorcentagem(analise.percentualQuantidade)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:green;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         }

//                         if (analise.percentualValorUnitario < 0) {
//                             table += `<b>Qtde.: </b>
//     <br />
//     ${ this.formatarPorcentagem(analise.percentualValorUnitario)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:red;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         } else {
//                             table += `<b>Qtde.: </b>
//     <br />
//     ${ this.formatarPorcentagem(analise.percentualValorUnitario)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:green;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         }

//                         if (analise.percentualTotal < 0) {
//                             table += `<b>Qtde.: </b>
//     <br />
//     ${ this.formatarPorcentagem(analise.percentualTotal)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:grredeen;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         } else {
//                             table += `<b>Qtde.: </b>
//     <br />
//     ${ this.formatarPorcentagem(analise.percentualTotal)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:green;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         }

//                         table += `</span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 De acordo com as informações reportadas pelo Jurisdicionado, não se identificou impropriedades na análise
//             realizada no Relatório Físico-Financeiro de Execução do Contrato de Gestão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseRelatorioFisico) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseRelatorioFisico}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaServidoresContemplados) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.3. Servidores Contemplados na Relação de Pagamentos
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaServidoresContemplados) && (this.certificado.contratosGestaoCertificado.listaServidoresContemplados.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>
//               Conforme dispõe a Lei nº 12.781, de 30.12.97, atualizada pelas Leis nº 13.484/2004 e 14.158/2008,
//               em seu art. 15 c/c parágrafo único, é vedada a cessão de servidores da administração pública direta
//               autárquica e fundacional do Estado de qualquer dos poderes, bem como de empregados das empresas públicas
//               e sociedades de economia mista do Estado para servirem ou trabalharem nas organizações sociais,
//               com exceção dos servidores públicos do Estado que se encontrem afastados de suas atividades,
//               para trato de interesse particular nos termos do Art. 115 e seguintes da Lei nº 9.826,
//               de 14 de maio de 1974 (Estatuto dos Funcionários Públicos Civis do Estado do Ceará).
//             </p>
//             <p>De acordo com as informações reportadas pelo Jurisdicionado e com base no sistema de
//               folha do Estado do Ceará, identificou-se servidor do Estado do Ceará na relação de pagamentos
//               realizados para fornecedor do Contrato de Gestão, constantes na Relação dos Pagamentos Realizados,
//               relacionados abaixo.
//             </p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dados do Contrato
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Pagamento </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Órgao de Vínculo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Recebido
// </span></b>
// </p>
// </td>   

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Referência
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Responsável pelo Contrato
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaServidoresContemplados.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nome}<br />
//                 <b>Matrícula:</b> ${ analise.nmMatricula} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>CNPJ:</b> ${ this.cnpj_mask(analise.cnpj)}
// <br />
// <b>Nº Contrato:</b> ${ analise.numeroContrato}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valPagamento)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.orgEmpresa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valRecebido)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmMes}/${analise.nmAno}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>CPF:</b> ${ this.cpf_mask(analise.cpf)}
//                 <br />
//                 <b>Responsável:</b> ${ analise.responsavel}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 <p>De acordo com as informações reportadas pelo Jurisdicionado e com base no sistema de folha do Estado do
//               Ceará,
//               não foi identificado servidor do Estado do Ceará na relação de pagamentos realizados para fornecedor
//               do Contrato de Gestão, constantes na Relação dos Pagamentos Realizados.</p>
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseServidoresContemplados) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseServidoresContemplados}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaPagamentosVsPessoal) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.4. Relação de Pagamentos Vs Relação de Pessoal
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaPagamentosVsPessoal) && (this.certificado.contratosGestaoCertificado.listaPagamentosVsPessoal.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>De acordo com as informações reportadas pelo Jurisdicionado, verificou-se a realização de pagamento,
// com base na Relação dos Pagamentos Realizados,
// para empregado constante na Relação de Pessoal Vinculado ao Contrato de Gestão, listados abaixo.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato de Gestão
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Período Contratação </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Remuneração Recebida
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Relação de Pagamento
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaPagamentosVsPessoal.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorioPagamento.contratoGestao.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relacaoPessoal.nomePessoa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início: </b> ${ analise.relacaoPessoal.dataAdmissao}
//                 <br />
//                 <b>Fim: </b> ${ analise.relacaoPessoal.dataDesligamento}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Janeiro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorJaneiro)}
//                 <br />
//                 <b>Fevereiro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorFevereiro)}
//                 <br />
//                 <b>Março:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorMarco)}
//                 <br />
//                 <b>Abril:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorAbril)}
//                 <br />
//                 <b>Maio:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorMaio)}
//                 <br />
//                 <b>Junho:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorJunho)}
//                 <br />
//                 <b>Julho:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorJulho)}
//                 <br />
//                 <b>Agosto:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorAgosto)}
//                 <br />
//                 <b>Setembro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorSetembro)}
//                 <br />
//                 <b>Outubro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorOutubro)}
//                 <br />
//                 <b>Novembro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorNovembro)}
//                 <br />
//                 <b>Dezembro:</b> ${ this.formatarValorNumerico(analise.relacaoPessoal.valorDezembro)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nome: </b>${ analise.relatorioPagamento.credor}`;

//                         if (analise.relatorioPagamento.contratoGestao.cpf != '') {
//                             table += `<b>CPF: </b>
//   <span>${ this.cpf_mask(analise.relatorioPagamento.cpf)}</span>`;
//                         }

//                         table += `<b>Valor Pago: </b> ${this.formatarValorNumerico(analise.relatorioPagamento.valorPago)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 <p>De acordo com as informações reportadas pelo Jurisdicionado, não se identificou a realização de
//               pagamento,
//               com base na Relação dos Pagamentos Realizados, para empregado constante na Relação de Pessoal
//               Vinculado ao Contrato de Gestão.</p>
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnalisePagamentosVsPessoal) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnalisePagamentosVsPessoal}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaPagamentosDesacordoCompra) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.5. Pagamento em Desacordo com o Regulamento de Compra da OS
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaPagamentosDesacordoCompra) && (this.certificado.contratosGestaoCertificado.listaPagamentosDesacordoCompra.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Conforme dispõe a Lei nº 12.781, de 30.12.97, atualizada pelas Leis nº 13.484/2004 e 14.158/2008, em seu
// art. 18,
// deve a organização social publicar o regulamento próprio contendo os procedimentos que adotará para
// contratação de obras, serviços e empregados, bem como para compras com emprego de recursos provenientes
// do
// Poder Público, no prazo de noventa dias contados da assinatura do contrato de gestão.</p>
// <p>De acordo com as informações reportadas pelo Jurisdicionado, verificou-se a existência de pagamentos à
// fornecedores que não tiveram seu regulamento de compra cadastrado no sistema,
// conforme Informações dos Editais e Cotações Realizadas, relacionados abaixo.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Credor
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CPF/CNPJ
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Tipo Despesa </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Pago (R$)
// </span></b>
// </p>
// </td>
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaPagamentosDesacordoCompra.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.credor} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.cpf) {
//                             table += `${this.cpf_mask(analise.cpf)}`;
//                         } else if (analise.cnpj) {
//                             table += `${this.cnpj_mask(analise.cpf)}`;
//                         }

//                         table += `</span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.tipoDespesa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.totalPago)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 <p>De acordo com as informações reportadas pelo Jurisdicionado, não se verificou inconsistência na
//                 análise dos pagamentos à fornecedores com base no regulamento de compra cadastrado no sistema,
//                 conforme Informações dos Editais e Cotações Realizadas.</p>
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseDesacordoCompra) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseDesacordoCompra}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaTransferencia) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.6. Transferência de Recursos entre Contratos de Gestão
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaTransferencia) && (this.certificado.contratosGestaoCertificado.listaTransferencia.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Com base nas informações reportadas pelo jurisdicionado,
// foram identificadas divergências de transferências de recursos entre Contratos de Gestão.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor do Empréstimo
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Data da Reposição </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Prazo de Reposição
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Devolvido
// </span></b>
// </p>
// </td>    

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor da Correção
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Destinação do Valor
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Justificativa
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaTransferencia.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.contratoGestao.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorRetirado)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.dataRetornoRecurso}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.prazoReposicao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorRetorno)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorCorrecao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.destinacaoValor}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.justificativa}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 <p>Com base nas informações reportadas pelo jurisdicionado,
//               não se identificou divergência de transferência de recursos entre Contratos de Gestão.</p>
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseTransferencia) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseTransferencia}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaAnaliseRelatorioExec) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.7. Análise do Relatório de Execução da Receita e Despesa
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaAnaliseRelatorioExec) && (this.certificado.contratosGestaoCertificado.listaAnaliseRelatorioExec.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Conforme dispõe a Lei nº 12.781, de 30.12.97, atualizada pelas Leis nº 13.484/2004 e 14.158/2008,
//               em seu art. 10, § 1º, o contrato de gestão deve permitir ao Poder Público requerer a apresentação pela
//               entidade qualificada de relatório pertinente à execução do contrato de gestão, contendo comparativo
//               específico
//               das metas propostas com os resultados alcançados.</p>
//             <p>De acordo com as informações reportadas pelo Jurisdicionado, verificou-se impropriedades, listadas
//               abaixo,
//               do resultado da análise realizada no Relatório de Execução de Receita e Despesa do Contrato de Gestão.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato SACC/SCC
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Organização Social
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Receitas </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Despesas
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % de Participação
// </span></b>
// </p>
// </td>      
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Superavit?
// </span></b>
// </p>
// </td>     
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaAnaliseRelatorioExec.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorio.contratoGestao.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.relatorio.contratoGestao.credor}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <table>
//             <tr>
//               <td>Recursos Recebidos</td>
//               <td>${ this.formatarValorNumerico(analise.relatorio.recursosRecebidos)}</td>
//             </tr>
//             <tr>
//               <td>Restituições</td>
//               <td>${ this.formatarValorNumerico(analise.relatorio.restituicoes)}</td>
//             </tr>
//             <tr>
//               <td>Transferências</td>
//               <td>${ this.formatarValorNumerico(analise.relatorio.transferencias)}</td>
//             </tr>
//             <tr>
//               <td>Rendimentos Acumulados</td>
//               <td>${ this.formatarValorNumerico(analise.relatorio.rendAcumulados)}</td>
//             </tr>
//             <tr>
//               <td>Outras Receitas</td>
//               <td>${ this.formatarValorNumerico(analise.relatorio.outrasReceitas)}</td>
//             </tr>
//           </table>
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <table>
//               <tr>
//                 <td>Despesas do Período / Total das Despesas</td>
//                 <tdclass="has-text-centered">${ this.formatarValorNumerico(analise.percentualDespesasPeriodo)} </td>
//               </tr>
//               <tr>
//                 <td>Despesas Financeiras / Total das Despesas</td>
//                 <td class="has-text-centered">${ this.formatarValorNumerico(analise.percentualDespesasFinanceiras)}
//                 </td>
//               </tr>
//             </table>
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <table>
// <tr>
//   <td>Execução das Despesas</td>
//   <td>${ this.formatarPorcentagem(analise.execuaoReceitas)}</td>
// </tr>
// </table>
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.totalSuperavit <= 0) {
//                             table += `${this.formatarValorNumerico(analise.totalSuperavit)}
//  <span style="font-family:&quot;Arial&quot;,sans-serif;color:red;">
//    <i class="fa fa-arrow-down" aria-hidden="true"></i>
//  </span>`;
//                         } else {
//                             table += `${this.formatarValorNumerico(analise.totalSuperavit)}
//     <span style="font-family:&quot;Arial&quot;,sans-serif;color:green;">
//       <i class="fa fa-arrow-down" aria-hidden="true"></i>
//     </span>`;
//                         }

//                         table += `</span></span> </p>               
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 De acordo com as informações reportadas pelo Jurisdicionado, não se verificou impropriedades do resultado
//             da
//             análise realizada no Relatório de Execução de Receita e Despesa do Contrato de Gestão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseRelatorioExec) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseRelatorioExec}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaParcelaVsEmpenho) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.8. Parcelas Recebidas Vs Valores Empenhados
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaParcelaVsEmpenho) && (this.certificado.contratosGestaoCertificado.listaParcelaVsEmpenho.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Com base nas informações reportadas pelo jurisdicionado e com base no Sistema de Gestão Governamental
//               por Resultados - SIAFE, foram identificadas divergências entre os valores reportados como recursos
//               recebidos
//               pela Organização Social e valores empenhados para o Contrato de Gestão, listados abaixo.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Parcelas Recebidas
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valores Empenhados (R$) </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo (R$)
// </span></b>
// </p>
// </td>        
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaParcelaVsEmpenho.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.totalParcelasRecebidas)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.totalValorEmpenhos)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado e com base no Sistema de Gestão Governamental por
//             Resultados - SIAFE, não foram identificadas divergências entre os valores reportados como recursos
//             recebidos
//             pela Organização Social e valores empenhados para o Contrato de Gestão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseParcelaVsEmpenho) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseParcelaVsEmpenho}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaAnaliseDespesas) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.9. Análise das Despesas
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaAnaliseDespesas) && (this.certificado.contratosGestaoCertificado.listaAnaliseDespesas.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Com base nas informações reportadas pelo jurisdicionado, foram identificadas divergências no confronto
//             entre o total dos valores reportados como despesas no Relatório Físico-Financeiro e no Relatório de
//             Execução de Receita e Despesa do Contrato de Gestão, relacionados abaixo.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Organização Social
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato SACC/SCC
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Relatório Físico-Financeiro </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Relatório de Execução de Receita e Despesa
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaAnaliseDespesas.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.cpf} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmContrato}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.totalDespesasFisFin)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.totalDespesasRelExec)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diff)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências no confronto
//             entre o total dos valores reportados como despesas no Relatório Físico-Financeiro e no Relatório de
//             Execução
//             de Receita e Despesa do Contrato de Gestão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseDespesas) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseDespesas}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaRelacaoPessoalCG) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.10. Relação do Pessoal Vinculado ao Contrato de Gestão
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaRelacaoPessoalCG) && (this.certificado.contratosGestaoCertificado.listaRelacaoPessoalCG.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// <p>Conforme dispõe a Lei nº 12.781, de 30.12.97, atualizada pelas Leis nº 13.484/2004 e 14.158/2008,
//               em seu art. 15 c/c parágrafo único, é vedada a cessão de servidores da administração pública direta
//               autárquica e fundacional do Estado de qualquer dos poderes, bem como de empregados das empresas públicas
//               e sociedades de economia mista do Estado para servirem ou trabalharem nas organizações sociais,
//               com exceção dos servidores públicos do Estado que se encontrem afastados de suas atividades,
//               para trato de interesse particular nos termos do Art. 115 e seguintes da Lei nº 9.826,
//               de 14 de maio de 1974 (Estatuto dos Funcionários Públicos Civis do Estado do Ceará).</p>
//             <p>De acordo com as informações reportadas pelo Jurisdicionado e com base no sistema de folha
//               do Estado do Ceará, identificou-se servidor do Estado do Ceará servindo ou trabalhando na
//               Organização Social, conforme Relação de Pessoal Vinculado ao Contrato de Gestão,
//               relacionados abaixo.</p>
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Organização Social
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Dados Pessoais </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Órgão Vinculado
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td>  
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Remuneração Bruta
// </span></b>
// </p>
// </td>        
// </tr>`;

//                     this.certificado.contratosGestaoCertificado.listaRelacaoPessoalCG.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmContrato} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.orgSocial}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Nome:</b> ${ analise.nomePessoa}
//                 <br />
//                 <b>CPF:</b> ${ this.cpf_mask(analise.cpf)}
//                 <br />
//                 <b>Matrícula:</b> ${ analise.nmMatricula}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.orgEmpresa}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Admissão:</b> ${ analise.dataAdmissao}
// <br />
// <b>Desligamento:</b> ${ analise.dataDesligamento}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Janeiro:</b> ${ this.formatarValorNumerico(analise.valorJaneiro)}
//                 <br />
//                 <b>Fevereiro:</b> ${ this.formatarValorNumerico(analise.valorFevereiro)}
//                 <br />
//                 <b>Março:</b> ${ this.formatarValorNumerico(analise.valorMarco)}
//                 <br />
//                 <b>Abril:</b> ${ this.formatarValorNumerico(analise.valorAbril)}
//                 <br />
//                 <b>Maio:</b> ${ this.formatarValorNumerico(analise.valorMaio)}
//                 <br />
//                 <b>Junho:</b> ${ this.formatarValorNumerico(analise.valorJunho)}
//                 <br />
//                 <b>Julho:</b> ${ this.formatarValorNumerico(analise.valorJulho)}
//                 <br />
//                 <b>Agosto:</b> ${ this.formatarValorNumerico(analise.valorAgosto)}
//                 <br />
//                 <b>Setembro:</b> ${ this.formatarValorNumerico(analise.valorSetembro)}
//                 <br />
//                 <b>Outubro:</b> ${ this.formatarValorNumerico(analise.valorOutubro)}
//                 <br />
//                 <b>Novembro:</b> ${ this.formatarValorNumerico(analise.valorNovembro)}
//                 <br />
//                 <b>Dezembro:</b> ${ this.formatarValorNumerico(analise.valorDezembro)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 De acordo com as informações reportadas pelo Jurisdicionado e
//             com base no sistema de folha do Estado do Ceará, não se identificou servidor do Estado do Ceará
//             servindo ou trabalhando na Organização Social, conforme Relação de Pessoal Vinculado ao Contrato
//             de Gestão.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.parecerAnalisePessoalDemonstrativo) {
//                     table += `${this.certificado.contratosGestaoCertificado.parecerAnalisePessoalDemonstrativo}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.contratosGestaoCertificado.listaVerificacaoContratacao) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">12.11. Análise dos Períodos de Contratação Convergentes
//                 </span></b> </p>`;


//                 if ((this.certificado.contratosGestaoCertificado.listaVerificacaoContratacao) && (this.certificado.contratosGestaoCertificado.listaVerificacaoContratacao.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// De acordo com as informações reportadas pelo Jurisdicionado e com base na Relação do Pessoal Vinculado
//             aos Contratos de Gestão do Estado do Ceará, identificou-se a presença de empregado vinculado a mais de um
//             contrato de gestão com períodos de contratação convergentes, relacionados abaixo.
//                         </span>
// </p>
// <br/>`;

//                     this.certificado.contratosGestaoCertificado.listaVerificacaoContratacao.forEach(analise => {
//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrato
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CPF/CNPJ </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Org. Social
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Função
// </span></b>
// </p>
// </td>   

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Período
// </span></b>
// </p>
// </td>
// </tr>`;

//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nome} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmContrato}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.cpf) {
//                             table += `${this.cpf_mask(analise.cpf)}`;
//                         } else {
//                             table += `${this.cnpj_mask(analise.cpf)}`;
//                         }
//                         table += `</span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.orgSocial}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.funcao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início: </b> ${ analise.inicioContratacao}
//                 <br />
//                 <b>Fim: </b> ${ analise.fimContratacao}
// </span></span> </p>
// </td>

// </tr>

// <tr> <b>Contratos:</b></tr>

// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nº Contrat
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Org. Social
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Jurisdicionado </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Pessoa Vinculada
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Período
// </span></b>
// </p>
// </td>
// </tr>`;

//                         if (analise.listaContratosGestao.length > 0) {
//                             analise.listaContratosGestao.forEach(contrato => {
//                                 table += `<tr>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ contrato.contratoGestao.nmContrato} </span></span> </p>               
//     </td>
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="180">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${contrato.contratoGestao.responsavel}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     ${ contrato.dsJurisdicionado}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     <b>Nome: </b>
//                   <br/>${ contrato.nomePessoa}
//                   <br/>
//                   <b>CPF: </b>
//                   <br/>${ contrato.cpf}
//                   <br/>
//                   <b>Função: </b>
//                   <br/>${ contrato.funcaoDesenvolvida}
//     </span></span> </p>
//     </td>
    
//     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//     width="80">
//     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//     <b>Início: </b>${ contrato.dataAdmissao}
//     <br/>
//     <b>Fim: </b>${ contrato.dataDesligamento}
//     </span></span> </p>
//     </td>
    
//     </tr>`;
//                             });
//                         } else {
//                             table += `<tr><td>Não foi encontrado nenhum contrato de gestão para essa inconsistência.</td></tr>`;
//                         }

//                         table += `</tbody></table>`;
//                     });
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 De acordo com as informações reportadas pelo Jurisdicionado e com base na Relação do Pessoal Vinculado
//             aos Contratos de Gestão do Estado do Ceará, não se identificou a presença de empregado vinculado a mais de
//             um contrato de gestão com períodos de contratação convergentes.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.contratosGestaoCertificado.dsResultadoAnaliseContratacao) {
//                     table += `${this.certificado.contratosGestaoCertificado.dsResultadoAnaliseContratacao}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }
//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }

//     tabela_gm() {
//         let table = "";

//         if (this.certificado.gestaoMateriaisCertificado) {

//             table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 &nbsp; A Gestão de Materiais e Patrimônio, alusivo ao exercício em Analise, contempla as verificações concernentes aos ativos que sofreram redução 
//         do valor econômico, as aquisições, as alienações, as doações e os consumos relativos aos bens de consumo, móveis, imóveis e intangíveis.      
//                                         </span>
//                 </p>
//                 <br/>`;

//             if (this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.1. Indicador de Baixa de Estoque X Aquisições de Estoque
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao) && (this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise da relação entre o total da baixa ocorrida na conta de estoque e o total das aquisições de estoque.    
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Cod. da Conta
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Desc. da Conta
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Item </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Consumo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Aquisições
// </span></b>
// </p>
// </td>    
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % de Consumo
// </span></b>
// </p>
// </td>      
// </tr>`;

//                     this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.codigoConta} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.descricaoConta}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.item}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorConsumo)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorAquisicoes)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(this.formatarValorNumerico(this.calcularPorcentagem(analise)))}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         na Lista de Bens.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao.dsResultadoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseBaixaVsAquisiscao.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.gestaoMateriaisCertificado.analiseBaixavsSaldo) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.2. Indicador de Baixa de Estoque X Saldo Atual de Estoque
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseBaixavsSaldo) && (this.certificado.gestaoMateriaisCertificado.analiseBaixavsSaldo.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise da relação entre o total da baixa ocorrida na conta de estoque no exercício e o saldo atual do estoque. 
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Cod. da Conta
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Desc. da Conta
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Item
// </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Consumo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Aquisições
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// % de Consumo
// </span></b>
// </p>
// </td>
// </tr>`;

//                     this.certificado.gestaoMateriaisCertificado.analiseTCEPrestacaoPendente.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.codigoConta} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.descricaoConta}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.item}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorConsumo)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(this.somarAquisicoes(analise))}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(this.formatarValorNumerico(this.calcularPorcentagem(analise)))}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre o indicador de baixa
//                         de estoque e o saldo atual.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseBaixavsSaldo.dsResultadoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseBaixavsSaldo.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.3. Relação das Alienações e Doações Realizadas
//                     3/2017)
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes) && (this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise das alienções e doações dos bens Móveis e Imóveis realizados no exercício.
//                         </span>
// </p>
// <br/>`;

//                     if (this.listaAlienacoes && this.listaAlienacoes.length > 0) {
//                         table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                         </span>
//                         » Alienações
// </p>
// <br/>`;

//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Tombamento
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Especificação
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor da Avaliação </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor da Alienação
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>  

// </tr>`;

//                         this.listaAlienacoes.forEach(analise => {
//                             table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmTombamento} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.especificacao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorAvaliacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorAlienacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                             divergências
//                             na Relação das Alienações.
//                                         </span>
//                 </p>
//                 <br/>`;
//                     }



//                     if (this.listaDoacoes && this.listaDoacoes.length > 0) {
//                         table += `<br />
//                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                             </span>
//                                             » Doações
//                     </p>
//                     <br/>`;

//                         table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                     cellspacing="0" cellpadding="0" border="0">
//                     <tbody>
//                     <tr style="height:15.0pt">
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Tombamento
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="180">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Especificação
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Decreto </span> </b> </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Data da Publicação do Decreto do DOE
//                     </span></b>
//                     </p>
//                     </td>
//                     <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                     width="80">
//                     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                     Valor da Baixa
//                     </span></b>
//                     </p>
//                     </td>  
                    
//                     </tr>`;

//                         this.listaDoacoes.forEach(analise => {
//                             table += `<tr>
//                     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                     width="80">
//                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                     ${ analise.nmTombamento} </span></span> </p>               
//                     </td>
//                     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                     width="180">
//                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                     ${ analise.especificacao}
//                     </span></span> </p>
//                     </td>
                    
//                     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                     width="80">
//                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                     ${ analise.decreto}
//                     </span></span> </p>
//                     </td>
                    
//                     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                     width="80">
//                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                     ${ analise.publicacao}
//                     </span></span> </p>
//                     </td>
                    
//                     <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
//                     width="80">
//                     <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//                     ${ this.formatarValorNumerico(analise.valorBaixa)}
//                     </span></span> </p>
//                     </td>
                    
//                     </tr>`;
//                         });
//                         table += `</tbody></table>`;
//                     } else {
//                         table += `<br />
//                                     <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                                     Com base nas informações reportadas pelo jurisdicionado, não foram identificadas
//                             divergências
//                             nas Doações Realizadas.
//                                                             </span>
//                                     </p>
//                                     <br/>`;
//                     }

//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre o indicador de Baixa
//                         de estoque e as aquisições de estoque.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.dsResultadoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseAlienacoesDoacoes.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.4. Análise dos Saldos contábeis - Listas de Bens x Balanço Patrimonial
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis) && (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Confronto entre os valores dos campos 'Saldo Geral' das Tableas de Ativos (Consumo, Móveis, Imóveis e Intangíveis) declaradas com o saldo das contas correspondentes no Balancete.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome da Tabela
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Conta
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo da Tabela </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Saldo da Conta no Balanço Patrimonial
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.nmTabela} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.codigo}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.vlSaldoTabela)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.vlSaldoBalancoPatrimonial)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         na Lista de Bens.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis.dsResultadoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeis.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.5. Reconhecimento do Resultado das Alienações
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens.analises) && (this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Análise do resultado dos valores da alienação realizada no exercício, declaradas nas tabelas Alienações Patrimoniais dos Bens Móveis e Alienções Patrimoniais dos Bens Imóveis.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Tombamento
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Especificação
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor da Avaliação
// </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor da Alienação
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens.analises.forEach(analise => {
//                         analise.lstInfra.forEach(itemII => {
//                             table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ itemII.nmTombamento} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ itemII.especificacao}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(itemII.valorAvaliacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(itemII.valorAlienacao)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(itemII.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                         });



//                         table += `
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">`;

//                         if (this.maiorQZero(analise.valorBal)) {
//                             table += `Ganhos com Alienação (Balancete)`;
//                         } else {
//                             table += `Perdas com Alienação (Balancete)`;
//                         }

//                         table += `</span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">`;

//                         if (this.maiorQZero(analise.valorJur)) {
//                             table += `Ganhos com Alienação (Jurisdicionado)`;
//                         } else {
//                             table += `Perdas com Alienação (Jurisdicionado)`;
//                         }

//                         table += `</span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td> 
// </tr>`;

//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorBal)} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valorJur)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>
// </tr>`;


//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                         entre as informações reportadas
//                         e o Balancete.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens.dsResultadoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseReconhecimentoAliens.dsResultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">13.6. Análise dos Saldos contábeis - Tabelas x Balancete
//                 </span></b> </p>`;


//                 if ((this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete.analises) && (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete.analises.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Confronto dos totais dos valores declarados das contas Depreciação, Amortização, Exaustão e Redução ao valor recuperável nas tabelas do Inventário Sintético de Bens Patrimoniais Móveis, 
//                         Inventários Sintético de Bens Patrimoniais Imóveis e Inventários Sintético de Bens Intangíveis com os valores dos campos no Balancete Contábil.
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Descrição
// </span></b>
// </p>
// </td>
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Bens Intangíveis
// </span></b>
// </p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Bens Imóveis </span> </b> </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total Bens Móveis
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Total
// </span></b>
// </p>
// </td>  

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Balancete
// </span></b>
// </p>
// </td> 

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete.analises.forEach(analise => {
//                         table += `<tr>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.tipo} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valIntangiveis)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valImoveis)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valMoveis)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valTotal)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.valBalancete)}
// </span></span> </p>
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarValorNumerico(analise.diferenca)}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências
//                 entre as informações reportadas
//                 e o Balancete.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete.dsResumoAnalise) {
//                     table += `${this.certificado.gestaoMateriaisCertificado.analiseSaldosContabeisTabelasBalancete.dsResumoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }
//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }
//     //#endregion

//     // ok
//     //#region Sprint 6
//     tabela_monitoramento() {
//         let table = "";

//         if (this.monitoramentoBaixa.length > 0) {
//             table += `<ul>
// <li> Sugestão de Baixa</li>
// </ul>
// <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Analisando as evidências e comentários apresentados nesta Prestação de Contas, constatou-se o devido cumprimento às determinações
// e recomendações expedidas nos acórdãos abaixo relacionados, motivo pelo qual esta unidade técnica sugere as respectivas
// baixas no SAP.</span></span>
// </p>

// <p class="MsoNormal" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center">
//     <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language: PT-BR">
//         QUADRO 06 - DETERMINAÇÕES SUGERIDAS PARA BAIXA</span>
// </p>

// <table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//     cellspacing="0" cellpadding="0" border="0">
//     <tbody>
//         <tr style="height:15.0pt">
//             <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="98">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Nº Processo no TCE/CE
//                         </span></b>
//                 </p>
//             </td>
//             <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="92">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Nº Acórdão/Resolução
//                         </span></b>
//                 </p>
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                 width="61">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Tipo </span> </b> </p>
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                 width="400">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <b style="mso-bidi-font-weight:normal">
//                         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                             Descrição </span> </b> </p>
//             </td>
//         </tr>`;

//             this.monitoramentoBaixa.forEach(item => {
//                 table += `<tr style="height:15.0pt">
// <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="98">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//             ${item.numeroProcesso}
//         </span></p>
// </td>
// <td style="width:69.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//     width="92">
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//             ${item.numeroAcordao}
//         </span></p>
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//     width="61">
    
//     <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">`;

//                 if (item.tipoDeterminacao == 1) {
//                     table += `Determinação`;
//                 } else {
//                     table += `Recomendação`;
//                 }

//                 table += `</span></p>                            
// </td>
// <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//     width="400">
    
//     <p class="MsoNormal" style="text-align:justify;layout-grid-mode: char">
//         <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//             ${item.descricao}
//         </span></p>                            
// </td>
// </tr>`;
//             });

//             table += `</tbody>
//             </table>`;
//         }

//         if (this.monitoramentoReincidencia.length > 0) {
//             table += `<ul>
//             <li> Reincidência</li>
//             </ul>
//             <br />
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//             Conforme pesquisa realizada no SAP e análises realizadas aos comentários e evidências fornecidas pelo Jurisdicionado, constatou-se
//             a possível existência de reincidência de Determinações/Recomendações.</span></span>
//             </p>
            
//             <p class="MsoNormal" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language: PT-BR">
//                     QUADRO 07 - REINCIDÊNCIA DE DETERMINAÇÕES</span>
//             </p>
            
//             <table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr style="height:15.0pt">
//                         <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                             width="98">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Nº Processo no TCE/CE
//                                     </span></b>
//                             </p>
//                         </td>
//                         <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                             width="92">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Nº Acórdão/Resolução
//                                     </span></b>
//                             </p>
//                         </td>
//                         <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                             width="61">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Tipo </span> </b> </p>
//                         </td>
//                         <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                             width="400">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Descrição </span> </b> </p>
//                         </td>
//                     </tr>
//             `;

//             this.monitoramentoReincidencia.forEach(item => {
//                 table += `<tr style="height:15.0pt">
//             <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="98">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.numeroProcesso}
//                     </span></p>
//             </td>
//             <td style="width:69.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="92">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.numeroAcordao}
//                     </span></p>
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//                 width="61">
                
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">`

//                 if (item.tipoDeterminacao == 1) {
//                     table += `Determinação`;
//                 } else {
//                     table += `Recomendação`;
//                 }

//                 table += `</span></p>                            
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//                 width="400">
                
//                 <p class="MsoNormal" style="text-align:justify;layout-grid-mode: char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.descricao}
//                     </span></p>                            
//             </td>
//             </tr>`;
//             });

//             table += `</tbody>
//                         </table>`;
//         }

//         if (this.monitoramentoOutros.length > 0) {
//             table += `<ul>
//             <li> Solicitação de Informações Adicionais</li>
//             </ul>
//             <br />
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//             Outrossim, constatou-se a insuficiência no tratamento das determinações e recomendações expedidas nos acórdãos abaixo relacionados,
//             motivo pelo qual esta unidade técnica sugere a solicitação de esclarecimentos adicionais, com vistas as devidas
//             baixas no SAP.</span></span>
//             </p>
            
//             <p class="MsoNormal" style="text-align:center;text-indent:0cm; line-height:10.0pt;layout-grid-mode:char" align="center">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language: PT-BR">
//                     QUADRO 08 - SOLICITAÇÃO DE INFORMAÇÕES ADICIONAIS</span>
//             </p>
            
//             <table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
//                 cellspacing="0" cellpadding="0" border="0">
//                 <tbody>
//                     <tr style="height:15.0pt">
//                         <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                             width="98">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Nº Processo no TCE/CE
//                                     </span></b>
//                             </p>
//                         </td>
//                         <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                             width="92">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Nº Acórdão/Resolução
//                                     </span></b>
//                             </p>
//                         </td>
//                         <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                             width="61">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Tipo </span> </b> </p>
//                         </td>
//                         <td style="width:346.0pt;border:solid black 1.0pt;mso-border-alt: solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt;height:15.0pt"
//                             width="400">
//                             <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                                 <b style="mso-bidi-font-weight:normal">
//                                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
//                                         Descrição </span> </b> </p>
//                         </td>
//                     </tr>
//             `;

//             this.monitoramentoOutros.forEach(item => {
//                 table += `<tr style="height:15.0pt">
//             <td style="width:73.5pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="98">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.numeroProcesso}
//                     </span></p>
//             </td>
//             <td style="width:69.0pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
//                 width="92">
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.numeroAcordao}
//                     </span></p>
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//                 width="61">
                
//                 <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">`

//                 if (item.tipoDeterminacao == 1) {
//                     table += `Determinação`;
//                 } else {
//                     table += `Recomendação`;
//                 }

//                 table += `</span></p>                            
//             </td>
//             <td style="width:346.0pt;border:solid black 1.0pt;border-top:none; mso-border-left-alt:solid black .5pt;mso-border-bottom-alt:solid black .5pt; mso-border-right-alt:solid black .5pt;padding:0cm 3.5pt 0cm 3.5pt;height: 15.0pt"
//                 width="400">
                
//                 <p class="MsoNormal" style="text-align:justify;layout-grid-mode: char">
//                     <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif;mso-fareast-language:PT-BR">
//                         ${item.descricao}
//                     </span></p>                            
//             </td>
//             </tr>`;
//             });

//             table += `</tbody>
//                         </table>`;
//         }

//         if (!this.certificado.lstMonitoramentoCertificado) {
//             table += `
//             <br />
//             <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//             Conforme pesquisa realizada no Sistema de Acompanhamento de Processos - SAP, constatou-se que não existem Determinações/Recomendações
//       as quais esta Unidade Técnica sugere à consideração superior desta Colenda Corte de Contas.</span>
//             </p>`
//         }


//         return table;
//     }

//     tabela_pessoal() {
//         let table = "";

//         if (this.certificado.pessoalCertificado) {

//             if (this.certificado.pessoalCertificado.visaoGerencialElemento31Wrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.1. Visão Gerencial - Gastos com Pessoal
//                 </span></b> </p>
                
//                 <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// No presente tópico, a partir das informações prestadas pelo jurisdicionado, estão abordados os principais
//             pontos relacionados
//             à composição e gastos com pessoal no exercício em análise.
//             <br />
//             <br /> O gráfico a seguir demonstra a composição dos gastos.
// </span>
// </p>
// <br/>`;
//                 if ((this.certificado.pessoalCertificado.visaoGerencialElemento31Wrapper.modalidades) && (this.certificado.pessoalCertificado.visaoGerencialElemento31Wrapper.modalidades > 0)) {

//                     table += `<div #chart id="chart2"></div>`;

//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.visaoGerencialElemento31Wrapper.resultadoAnalise) {
//                     table += `${this.certificado.pessoalCertificado.visaoGerencialElemento31Wrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.pessoalCertificado.visaoGerencialWrapper) {
//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.2. Visão Gerencial
//                 </span></b> </p>
                
//                 <br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// A regra para investidura em cargo ou emprego público na administração direta, indireta ou fundacional,
//             segundo dispõe a Lei
//             Maior do Estado, no inciso II, do art. 154, é a aprovação em concurso público. Ademais, as funções de
//             confiança
//             devem ser exercidas por servidores ocupantes de cargo efetivo e os cargos em comissão por servidores de
//             carreira,
//             segundo o inciso V, do citado art. 154.

//             <br />
//             <br /> O gráfico a seguir demonstra a composição do quadro de pessoal.
// </span>
// </p>
// <br/>`;
//                 if ((this.certificado.pessoalCertificado.visaoGerencialWrapper.vinculos) && (this.certificado.pessoalCertificado.visaoGerencialWrapper.vinculos > 0)) {

//                     table += `<div #chart id="chart1"></div>`;

//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.visaoGerencialWrapper.resultadoAnalise) {
//                     table += `${this.certificado.pessoalCertificado.visaoGerencialWrapper.resultadoAnalise}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;
//             }

//             if (this.certificado.pessoalCertificado.listaAnalise1) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.3. Análise Horizontal da Composição do Quadro de Pessoal
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise1) && (this.certificado.pessoalCertificado.listaAnalise1.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Tomando-se por base o vínculo funcional, realizou-se uma análise horizontal da composição do Quadro de
//             Pessoal, cujo resultado
//             aponta divergências nos vínculos relacionados no quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td rowspan="2" style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vínculo
// </span></b>
// </p>
// </td>

// <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Quantitativo
// </span></b>
// </p>
// </td>

// <td colspan="3" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ocupados
// </span></b>
// </p>
// </td>
// </tr>

// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Análise Horizontal (%)
// </span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Análise Horizontal (%)
// </span></b>
// </p>
// </td>
// </tr>`;

//                     this.certificado.pessoalCertificado.listaAnalise1.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.vinculo.dsGrupoCargo}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaInicioExercicio} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaFinalExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseHorizontalQuantitativo)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaOcupadosInicioExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaOcupadosFinalExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseHorizontalOcupados)}
//                  </span></span> </p>               
// </td>


// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências na composição
//             do Quadro de
//             Pessoal, a partir de sua Ánalise Horizontal.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalHzQuantitativoCargos) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalHzQuantitativoCargos}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.pessoalCertificado.listaAnalise2) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.4. Análise Vertical da Composição do Quadro de Pessoal
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise2) && (this.certificado.pessoalCertificado.listaAnalise2.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Da mesma forma, tomando-se por base o vínculo funcional, realizou-se uma análise vertical da composição do
//             Quadro de Pessoal,
//             cujo resultado aponta divergências nos vínculos relacionados no quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td rowspan="2" style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vínculo
// </span></b>
// </p>
// </td>

// <td colspan="4" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Quantitativo
// </span></b>
// </p>
// </td>

// <td colspan="4" style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ocupados
// </span></b>
// </p>
// </td>
// </tr>

// <tr style="height:15.0pt">
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Análise Vertical (%)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vertical</span></b>
// </p>
// </td>

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Anterior
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Análise Vertical (%)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. Exercício Atual
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vertical</span></b>
// </p>
// </td>
// </tr>`;

//                     this.certificado.pessoalCertificado.listaAnalise2.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.vinculo.dsGrupoCargo}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaInicioExercicio} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseVerticalOcupadosInicioExercicio)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaFinalExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseVerticalFinalExercicio)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaOcupadosInicioExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseVerticalOcupadosInicioExercicio)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.somaOcupadosFinalExercicio}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.formatarPorcentagem(analise.analiseVerticalOcupadosFinalExercicio)}
//                  </span></span> </p>               
// </td>


// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências na composição
//             do Quadro de
//             Pessoal, a partir de sua Ánalise Vertical.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalVtQuantitativoCargos) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalVtQuantitativoCargos}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.pessoalCertificado.listaAnalise3) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.5. Divergências entre a Composição do Quadro de Pessoal e o Quantitativo de Cargos Ocupados
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise3) && (this.certificado.pessoalCertificado.listaAnalise3.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Do confronto entre os cargos disponíveis e as nomeações realizadas, foram identificadas divergências na
//             composição do quadro
//             de pessoal, relacionadas no quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Cargo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. (Quadro de Pessoal)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. (Cargos Nomeados)
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Diferença
// </span></b>
// </p>
// </td>         
// </tr>`;

//                     this.certificado.pessoalCertificado.listaAnalise3.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.cargo.nomeCargo}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.qtdCargosDem} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.qtdCargosQuadro}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${this.calcularDiferenca(analise)}
//                  </span></span> </p>               
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências na composição
//             do Quadro de
//             Pessoal, a partir da análise dos Cargos disponíveis em confronto com as Nomeações realizadas no exercício.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalDemVsQuadro) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalDemVsQuadro}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.pessoalCertificado.listaAnalise4) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.6. Análise do Quadro de Nomeação de Cargos versus SRP
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise4) && (this.certificado.pessoalCertificado.listaAnalise4.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Do confronto entre as nomeações realizadas e o sistema SRP, foram identificadas divergências nas
//             nomeações referentes ao envio do Ato de Nomeação ao SRP, relacionadas no quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vínculo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Cargo/Posto de Trabalho
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Nome
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CPF
// </span></b>
// </p>
// </td>   
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="100">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Datas
// </span></b>
// </p>
// </td>       
// </tr>`;

//                     this.certificado.pessoalCertificado.listaAnalise4.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.quadro.grupoCargoModel.dsGrupoCargo}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.quadro.cargo.nomeCargo} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.quadro.dsNome}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${this.cpf_mask(analise.quadro.cpf)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="100">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Edital:</b> ${ analise.quadro.dtEdital}
//                 <br />
//                 <b>Resultado:</b> ${ analise.quadro.dtResultado}
//                 <br />
//                 <b> Homologação: </b> ${ analise.quadro.dtHomologacao}
//                 <br />
//                 <b> Nomeação: </b> ${ analise.quadro.dtNomeacao}
//                 <br />
//                 <b> Exoneração: </b> ${ analise.quadro.dtExoneracao}
// </span></span> </p>
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências nas
//             nomeações referentes ao envio do Ato de Nomeação ao SRP.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalNomeacaoVsSRP) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalNomeacaoVsSRP}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.pessoalCertificado.listaAnalise5) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.7. Análise da Terceirização de Mão-de-Obra
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise5) && (this.certificado.pessoalCertificado.listaAnalise5.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Na análise da terceirização de mão de obra, foram identificadas as divergências relacionadas no quadro
//             abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Contrato
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Credor
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// CPF/CNPJ
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Valor Contratado
// </span></b>
// </p>
// </td>   
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vigência
// </span></b>
// </p>
// </td>  

// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Objeto
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Arquivos
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Atribuições
// </span></b>
// </p>
// </td> 
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="80">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Qtde. de Postos de Trabalho
// </span></b>
// </p>
// </td> 
// </tr>`;

//                     this.certificado.pessoalCertificado.listaAnalise5.forEach(analise => {
//                         table += `<tr>
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.referencia.numeroContrato}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.referencia.dsCredor} </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ this.cnpj_mask(analise.referencia.cnpj)}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${this.formatarValorNumerico(analise.referencia.valorContratado)}
//                  </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início:</b> ${ analise.referencia.inicioVigencia}
//                 <br />
//                 <b>Fim:</b> ${ analise.referencia.fimVigencia}
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.referencia.objeto} </span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.referencia.arquivos.length > 0) {
//                             table += `Sim`;
//                         } else {
//                             table += `Não`;
//                         }


//                         table += `</span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">`;

//                         if (analise.referencia.atividadeTerceirizacoes.length > 0) {
//                             table += `Sim`;
//                         } else {
//                             table += `Não`;
//                         }

//                         table += `</span></span> </p>               
// </td>

// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="80">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// ${ analise.referencia.qtdPostoTrabalho} </span></span> </p>               
// </td>

// </tr>`;
//                     });
//                     table += `</tbody></table>`;
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências relativas à
//             Terceirização de
//             Mão-de-Obra.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalReferencia) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalReferencia}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//             if (this.certificado.pessoalCertificado.listaAnalise7) {

//                 table += `<p class="WW-Recuodecorpodetexto212" style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:15.0pt">14.8. Análise do Quantitativo do Quadro de Pessoal
//                 </span></b> </p>`;


//                 if ((this.certificado.pessoalCertificado.listaAnalise7) && (this.certificado.pessoalCertificado.listaAnalise7.length > 0)) {

//                     table += `<br />
// <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
// Por fim, realizou análise relativa ao quantitativo do quadro de pessoal, tendo identificadas as
//             divergências apontadas no
//             quadro abaixo:
//                         </span>
// </p>
// <br/>`;

//                     table += `<table class="MsoNormalTable" style="margin-left:4.05pt;border-collapse:collapse;mso-table-layout-alt:fixed; mso-padding-alt:0cm 3.5pt 0cm 3.5pt"
// cellspacing="0" cellpadding="0" border="0">
// <tbody>
// <tr style="height:15.0pt">
// <td style="width:69.0pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="180">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Vínculo
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Quantitativos
// </span></b>
// </p>
// </td>
// <td style="width:73.5pt;border:solid black 1.0pt;border-right:none; mso-border-top-alt:solid black .5pt;mso-border-left-alt:solid black .5pt; mso-border-bottom-alt:solid black .5pt;background:#D9D9D9;padding:0cm 3.5pt 0cm 3.5pt; height:15.0pt"
// width="120">
// <p class="MsoNormal" style="text-align:center;layout-grid-mode: char" align="center">
// <b style="mso-bidi-font-weight:normal">
// <span style="font-family:&quot;Arial&quot;,sans-serif;font-family:&quot;Arial&quot;,sans-serif; mso-fareast-language:PT-BR">
// Ocupados
// </span></b>
// </p>
// </td>
// </tr>`;

//                     // this.certificado.pessoalCertificado.listaAnalise7.forEach(analise => {
//                     table += `<tr *ngFor="let analise of this.certificado.pessoalCertificado.listaAnalise7 | groupBy : 'demonstrativo.vinculo.dsGrupoCargo' | pairs | orderByImpure : 'demonstrativo.vinculo.dsGrupoCargo'">
//                         <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="180">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
//  analise[0]
// </span></span> </p>
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:none;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início do Exercício:</b>  this.somarInicioExercicio(analise) 
// <br />
// <b>Criados no Exercício:</b>  this.somarCriadosExercicio(analise) 
// <br />
// <b>Extintos no Exercício:</b>  this.somarExtintosExercicio(analise) 
// <br />
// <b>Final no Exercício:</b>  this.somarFinalExercicio(analise) 
// </span></span> </p>               
// </td>
// <td style="width:116.25pt;border-top:none;border-left:solid black 1.0pt; border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;mso-border-left-alt:solid black .25pt; mso-border-bottom-alt:solid black .25pt;padding:2.75pt 2.75pt 2.75pt 2.75pt"
// width="120">
// <p class="Contedodatabela0"> <span class="MsoHyperlink"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 9.0pt;font-family:&quot;Arial&quot;,sans-serif">
// <b>Início do Exercício:</b>  this.somarOcupadosInicioExercicio(analise) 
//                 <br />
//                 <b>Nomeados no Exercício:</b>  this.somarNomeadosExercicio(analise) 
//                 <br />
//                 <b>Exonerados/Outros no Exercício:</b>  this.somarCargosExoneradosExercicio(analise) 
//                 <br />
//                 <b>Final no Exercício:</b>  this.somarOcupadosfinalExercicio(analise) 
//                 <br />
//                 <b>Vagos no Final no Exercício:</b>  this.somarCargosVagosFinalExercicio(analise) 
// </span></span> </p>
// </td>
// </tr>
// </tbody></table>`;
//                     // });
//                 } else {
//                     table += `<br />
//                 <p class="MsoNormal" style="text-align:justify;text-indent:70.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">
//                 Com base nas informações reportadas pelo jurisdicionado, não foram identificadas divergências relativas ao
//             Quadro de Pessoal.
//                                         </span>
//                 </p>
//                 <br/>`;
//                 }

//                 table += `<p style="margin-bottom:8.5pt;text-indent:80.5pt; mso-line-height-alt:15.0pt"><b
//                 style="mso-bidi-font-weight:normal"><span style="font-family:&quot;Arial&quot;,sans-serif;font-size:12.0pt">Parecer do Analista
//                 </span></b> </p>
//                 <p class="MsoNormal" style="text-align:justify;text-indent:90.5pt;line-height: 150%;tab-stops:18.0pt 126.0pt;layout-grid-mode:char">
//                 <span style="font-family:&quot;Arial&quot;,sans-serif;font-size: 11.0pt;line-height:150%;font-family:&quot;Arial&quot;,sans-serif">`;

//                 if (this.certificado.pessoalCertificado.parecerAnalisePessoalDemonstrativo) {
//                     table += `${this.certificado.pessoalCertificado.parecerAnalisePessoalDemonstrativo}`;
//                 } else {
//                     table += `O parecer do analista não foi preenchido.`;
//                 }
//                 table += `</span>
//                 </p>`;

//             }

//         } else {
//             table = `<p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt;line-height:150%">
//             <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;line-height: 150%;mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal">
//             Não há registros incluídos no cerficado.</span></p>
//         <p class="WW-Recuodecorpodetexto3" style="margin:0cm;margin-bottom:.0001pt; text-indent:70.85pt"> <span style="font-family:&quot;Arial&quot;,sans-serif;font-size:11.0pt;mso-bidi-font-size:12.0pt; mso-fareast-font-family:ArialMT;mso-fareast-language:#00FF;mso-bidi-language: #00FF;font-weight:normal"></span></p>`
//         }

//         return table;
//     }
//     //#endregion    

//     dataURItoBlob(dataURI) {
//         // convert base64/URLEncoded data component to raw binary data held in a string
//         var byteString;
//         if (dataURI.split(',')[0].indexOf('base64') >= 0)
//             byteString = atob(dataURI.split(',')[1]);
//         else
//             byteString = unescape(dataURI.split(',')[1]);

//         // separate out the mime component
//         var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

//         // write the bytes of the string to a typed array
//         var ia = new Uint8Array(byteString.length);
//         for (var i = 0; i < byteString.length; i++) {
//             ia[i] = byteString.charCodeAt(i);
//         }

//         return new Blob([ia], { type: mimeString });
//     }

//     autuar() {
//         this.loading = true;
//         let file: File = null;
//         let cert: any;

//         // $('.fa-print').click();

//         if (this.numeracao.nmProcesso == "") {
//             this.gerarNumeracao();
//         }

//         let options = {
//             height: 3600,
//             width: window.screen.width,
//             windowHeight: 3600,
//             windowWidth: window.screen.width
//         };


//         var myFrame = $("#iframePDF").contents().find('body');

//         window.html2canvas = html2canvas;

//         myFrame.html(this.certificadoContent);

//         console.log(myFrame[0]);
//         var doc = new jsPDF(
//             'p', 'pt', 'a4'
//         );
//         doc.html(myFrame[0]);
//         //   console.log(doc.output('datauristring'));
//         //   setTimeout(() => {
//         //       console.log("entrei no callback");
//         //     //   doc.save("teste.pdf");
//         //   }, 30000);

//         doc.addHTML(myFrame[0]).then(() => {
//             console.log("started");
//             doc.save()
//             console.log("finished");
//         });

//         // let doc = new jsPDF();
//         // console.log(document.getElementById("certificado").innerHTML);

//         // let c = myFrame[0];

//         // var content = document.getElementById("certificado").invoke('code');


//         // <HTMLScriptElement>
//         // doc.addHTML(HTMLScriptElement><any>document.getElementById("certificado")[0], function() {
//         //     doc.save("obrz.pdf");                
//         //  });
//         // doc.fromHTML(c, function() {
//         //     doc.save("obrz.pdf");                
//         //  });


//         let specialElementHandlers = {
//             // element with id of "bypass" - jQuery style selector
//             '#bypassme': function (element, renderer) {
//                 // true = "handled elsewhere, bypass text extraction"
//                 return true
//             }
//         };
//         let margins = {
//             top: 80,
//             bottom: 60,
//             left: 40,
//             width: 522
//         };

//         let nome = "certificado_" + this.numeracao.nmProcesso + "_" + this.numeracao.nmCertificado + ".pdf";
//         console.log(nome);
//         var outputBase64 = doc.output('datauristring');
//         var preBlob = this.dataURItoBlob(outputBase64);
//         file = new File([preBlob], nome, { type: 'application/pdf' });
//         // doc.save('teste_certificado.pdf');
//         this.fileService.salvarPecaFile(file, 0, this.idModuloPca, 0, 0, 1, 'NA').subscribe(data => {
//             data.idArquivoVinculado, data.idPca

//             let titulo = "Autuar PCA";

//             let modal = this.modalCtrl.create(ModalAutuacaoPage,
//                 {
//                     titulo: titulo,
//                     pca: this.PCAAtiva,
//                     idArquivoVinculado: data.idArquivoVinculado,
//                     processo: this.numeracao.nmProcesso
//                 });
//             modal.onDidDismiss(retornoModal => {
//                 if (retornoModal && retornoModal.flag) {
//                     this.loading = true;
//                 }
//                 this.loading = false;
//             });

//             modal.present();


//         }, error => {
//             this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar arquivo: " + error.mensagem);
//             this.loading = false;
//         });

//         // });

//         // });
//     }

//     //#region auxiliar

//     indicaComparacao(analise) {
//         let diff: any = "";

//         if (!analise.saldoS2GPR) {
//             diff = "Saldo Declarado X Saldo do Extrato";
//         } else if (!analise.saldoExtrato) {
//             diff = "Saldo Declarado X Saldo do SIAFE";
//         } else if (!analise.saldoConta) {
//             diff = "Saldo do SIAFE X Saldo do Extrato";
//         }

//         return diff;
//     }

//     maiorQZero(valor) {
//         return valor >= 0;
//     }

//     formatarValorNumerico(valor) {

//         if (!valor) {
//             valor = 0;
//         }

//         let valorFormatado = new Intl.NumberFormat('pt-BR',
//             {
//                 style: 'currency',
//                 currency: 'BRL'
//             }).format(valor);

//         return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
//     }

//     somarValorDosAcrescimos(contrato) {
//         let total: any = 0;

//         contrato.aditivos.forEach(aditivo => {
//             // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

//             // if (listaProdutosAditivo != null) {
//             //   contrato.listaProdutosAditivo.forEach(produto => {
//             //     if (produto.tipo == 'Acréscimo') {
//             total += aditivo.totalAcrescimo
//             //     }
//             //   });
//             // }
//         });

//         //let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;

//         return this.formatarValorNumerico(total);
//     }

//     somarValorDasSupressoes(contrato) {
//         let total: any = 0;

//         contrato.aditivos.forEach(aditivo => {
//             // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

//             // if (listaProdutosAditivo != null) {
//             //   contrato.listaProdutosAditivo.forEach(produto => {
//             //     if (produto.tipo == 'Supressão') {
//             total += aditivo.totalSupressao
//             //     }
//             //   //   });
//             //   // }
//         });

//         //let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;

//         return this.formatarValorNumerico(total);
//     }

//     calcularDiferencaAcrescimos(contrato) {
//         let total: any = 0;

//         contrato.aditivos.forEach(aditivo => {
//             // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

//             // if (listaProdutosAditivo != null) {
//             //   contrato.listaProdutosAditivo.forEach(produto => {
//             // if (aditivo.tipo == 'Acréscimo') {
//             total += aditivo.totalAcrescimo
//             // }
//             //   });
//             // }
//         });

//         let porcentagemAcrescimoSobreContrato = (total / contrato.valorAtual) * 100;
//         let diferencaLimiteAcrescimo = porcentagemAcrescimoSobreContrato - this.limiteDiferencaLimiteLegal;

//         return this.formatarPorcentagem(diferencaLimiteAcrescimo);
//     }

//     calcularDiferencaSupressoes(contrato) {
//         let total: any = 0;

//         contrato.aditivos.forEach(aditivo => {
//             // let listaProdutosAditivo = this.obterProdutosDoAditivo(aditivo.idAditivo);

//             // if (listaProdutosAditivo != null) {
//             // contrato.listaProdutosAditivo.forEach(produto => {
//             // if (aditivo.tipo == 'Supressão') {
//             total += aditivo.totalSupressao;
//             // }
//             // });
//             // }
//         });
//     }

//     formatarPorcentagem(valor) {


//         if (!valor) {
//             valor = 0;
//         }

//         let valorString = valor.toString();

//         if (valorString.indexOf('.') != -1) {
//             let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
//             let numeroDeCasasDecimais = 2;
//             valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
//         }

//         return valorString.replace('.', ',') + "%";
//     }

//     carregarGrafico() {

//         let opts: any = {
//             title: { text: 'Visão Gerencial das Licitações Realizadas' },
//             credits: {
//                 enabled: false
//             },
//             yAxis: {
//                 min: 0,
//                 title: {
//                     text: 'Volume de Recursos'
//                 }
//             },
//             xAxis: {
//                 type: 'category',
//                 labels: {
//                     style: {
//                         fontSize: '9px',
//                         fontFamily: 'Verdana, sans-serif'
//                     }
//                 }
//             },
//             tooltip: {
//                 formatter: function () {
//                     var seriesData = this.series.data;

//                     var total = 0;
//                     for (var i = 0; i < seriesData.length; i++) {
//                         total += seriesData[i].y
//                     }

//                     return '<span style="font-family:&quot;Arial&quot;,sans-serif;font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
//                         '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
//                         '<span style="font-family:&quot;Arial&quot;,sans-serif;color:' + this.color + '">Valor (R$)</span>: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
//                         '<span style="font-family:&quot;Arial&quot;,sans-serif;color:' + this.color + '">Total (R$)</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
//                 }
//             },
//             legend: {
//                 enabled: false
//             },
//             plotOptions: {
//                 series: {
//                     dataLabels: {
//                         enabled: true,
//                         formatter: function () {
//                             var seriesData = this.series.data;

//                             var total = 0;
//                             for (var i = 0; i < seriesData.length; i++) {
//                                 total += seriesData[i].y
//                             }

//                             return (100 * this.y / total).toFixed(2) + "%";
//                         }
//                     }
//                 }
//             },
//             series: [{
//                 name: 'Modalidades',
//                 colorByPoint: true,
//                 data: this.listaDadosRegra2
//             }]
//         };

//         if (this.chartEl && this.chartEl.nativeElement) {
//             opts.chart = {
//                 type: 'column',
//                 plotBackgroundColor: null,
//                 plotBorderWidth: 0,
//                 plotShadow: false,
//                 backgroundColor: 'transparent',
//                 renderTo: this.chartEl.nativeElement
//             };

//             this._chart = new Highcharts.Chart(opts);
//         }

//     }

//     public ngAfterViewInit(): void {
//         this.charts.changes.subscribe((comps: QueryList<ElementRef>) => {
//             this.chartEl = comps.first;

//             this.carregarGrafico();
//         });
//     }

//     calculaExecOrca(emp, dot) {
//         let calc = (emp / dot) * 100;

//         if (isNaN(calc)) calc = 0;

//         return this.formatarValorNumerico(calc);
//     }

//     somarInicioExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.inicioExercicio;
//         });

//         return val;
//     }

//     somarCriadosExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.criadosExercicio;
//         });

//         return val;
//     }

//     somarExtintosExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.extintosExercicio;
//         });

//         return val;
//     }

//     somarFinalExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.finalExercicio;
//         });

//         return val;
//     }

//     somarOcupadosInicioExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.ocupadosInicioExercicio;
//         });

//         return val;
//     }

//     somarNomeadosExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.nomeadosExercicio;
//         });

//         return val;
//     }

//     somarCargosExoneradosExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.cargosExoneradosExercicio;
//         });

//         return val;
//     }

//     somarOcupadosfinalExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.ocupadosfinalExercicio;
//         });

//         return val;
//     }

//     somarCargosVagosFinalExercicio(item) {
//         let val = 0;

//         item[1].forEach(element => {
//             val += +element.demonstrativo.cargosVagosFinalExercicio;
//         });

//         return val;
//     }

//     calcularDiferenca(item) {
//         return item.qtdCargosDem - item.qtdCargosQuadro;
//     }

//     cnpj_mask(v) {
//         v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
//         v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
//         v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
//         //de novo (para o segundo bloco de números)
//         v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
//         v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
//         return v;
//     }

//     calcularDiferencaData(item) {
//         const year = item.dtLimite.substr(6, 4);
//         const month = item.dtLimite.substr(3, 2);
//         const day = item.dtLimite.substr(0, 2);
//         const date = new Date(year, month, day);

//         var date1 = new Date(date);
//         var date2 = new Date();

//         var timeDiff = Math.abs(date2.getTime() - date1.getTime());

//         item.nmDiasAtrasados = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 30;

//         return item.nmDiasAtrasados;
//     }

//     somarAquisicoes(item) {
//         let retorno = 0;

//         if (item.valorAquisicoes) {
//             if (item.valorContabil) {
//                 retorno = (item.valorContabil + item.valorAquisicoes);
//             } else {
//                 retorno = item.valorAquisicoes;
//             }
//         } else if (item.valorContabil) {
//             retorno = item.valorContabil;
//         }

//         return retorno;
//     }

//     calcularPorcentagem(item) {
//         let retorno = 0;

//         if (item.valorAquisicoes && item.valorContabil) {
//             retorno = item.valorConsumo / (item.valorContabil + item.valorAquisicoes);
//         }

//         return retorno * 100;
//     }
//     //#endregion
 }



// WEBPACK FOOTER //
// ./src/pages/certificado/certificado.ts